import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Menu,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Upload,
} from "antd";
import { Option } from "antd/es/mentions";
import MenuItem from "antd/es/menu/MenuItem";
import moment from "moment";

import Swal from "sweetalert2";

import nutrientsApi from "../../../apis/Nutrients.api";
import productApi from "../../../apis/Product.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import { plutusS3 } from "../../../utils/plutusS3";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

import ProductDetailExplainComponent from "./ProductDetailExplainComponent";
import ProductReviewRefComponent from "./ProductReviewRefComponent";

const ProductRegisterComponent = ({ match }) => {
  let history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [product, setProduct] = useState({
    is_purchase: true,
    home_display_yn: true,
    is_admin_product: false,
    product_category_id: "",
    product_category_name: "",
    brand_commission_rate: 0.0,
    include_vat: true,
    commission_rate: 30.0,
    commission_rate_2: 20.0,
    commission_rate_3: 10.0,
    cancellation_information: "",
    cancellation_impossible_information: "",
    quality_assurance_standards_information: "",
    refund_indemnity_informaion: "",
    dispute_information: "",
    top_nutrient_content: 0,
    delivery_type: "당일 배송",
    delivery_due: 1,
    is_available_point: true,
    saving_point: 0,
    saving_point_type: 1,
    review_point: 0,
    review_point_type: 1,
    review_image_point: 0,
    review_image_point_type: 1,
    share_point: 0,
    product_kpi: 0,
    product_target: 99,
    product_type: null,
    hit: 0,
    nutrient_effect: "",
    nutrient_additional_ingredient: "",
    dayIntake: 0,
  });
  const [productDetail, setProductDetail] = useState({});
  const [productOptions, setProductOptions] = useState([
    {
      option_title: "1박스 1개월분",
      price_1: 0,
      price_2: 0,
      discount: 0,
      option_quantity: 1,
      option_description: "",
      option_type: "price",
      quantity: 0,
      directly_quantity: false,
      // 태그 추가
      tag_name: null,
      tag_background_color: null,
      tag_text_color: null,
    },
  ]);
  const [deleteOption, setDeleteOption] = useState([]);
  const [nutrients, setNutrients] = useState({
    is_certify: true,
    status: 1,
  });
  const [nutrientInfo, setNutrientInfo] = useState({
    target_type: 3,
    moisture: "", //수분(g)
    protein: "", //단백질(g)
    fat: "", //지방(g)
    carbohydrate: "", //탄수화물(g)
    total_sugar: "", //총당류(g)
    total_dietary_fiber: "", //총식이섬유(g)
    soluble_dietary_fiber: "", //수용성 식이섬유(g)
    insoluble_dietary_fiber: "", //불용성 식이섬유	(g)
    calcium: "", //칼슘(mg)
    fe: "", //철(mg)
    magnesium: "", //마그네슘(mg)
    perfect_virtue: "", //인(㎎)
    potassium: "", //칼륨(㎎)
    sodium: "", //나트륨(㎎)
    zinc: "", //아연(㎎)
    copper: "", //구리(㎎)
    manganese: "", //망간(㎎)
    selenium: "", //셀레늄(㎍)
    molybdenum: "", //몰리브덴(㎍)
    iodine: "", //요오드(㎍)
    retinol: "", //레티놀(㎍)
    beta_carotene: "", //베타카로틴(㎍)
    vitamin_a: "", //비타민 A(D2+D3)(㎍)
    vitamin_d: "", //비타민 D(D2+D3)(㎍)
    vitamin_e: "", //비타민 E(㎎)
    vitamin_k: "", //비타민 K(㎍)
    vitamin_k1: "", //비타민 K1(㎍)
    vitamin_k2: "", //비타민 K2(㎍)
    vitamin_b: "", //비타민B(mg)
    vitamin_b1: "", //티아민 - 비타민 B1(㎎)
    vitamin_b2: "", //리보플라빈 - 비타민 B2(㎎)
    vitamin_multi: "", //멀티비타민(mg)
    niacin: "", //나이아신(㎎)
    niacin_1: "", //나이아신(㎎ NE)
    niacin_2: "", //나이아신(NE)(㎎)
    niacin_3: "", //나이아신(NE)(㎎ NE)
    nicotinic_acid: "", //니코틴산 (㎎)
    nicotinamide: "", //니코틴아마이드(㎎)
    pantothenic_acid: "", //판토텐산(㎎)
    vitamin_b6: "", //비타민 B6(㎎)
    pyridoxine: "", //비타민 B6 - 피리독신(㎎)
    biotin: "", //비오틴(㎍)
    folic_acid: "", //엽산(DFE)(㎍)
    vitamin_b12: "", //비타민 B12(㎍)
    vitamin_c: "", //비타민 C(㎎)
    cholesterol: "", //콜레스테롤(g)
    cholesterol_1: "", //콜레스테롤(㎎)
    total_fatty_acids: "", //총 지방산(g)
    total_essential_fatty_acids: "", //총 필수 지방산(g)
    total_saturated_fatty_acids: "", //총 포화 지방산(g)
    total_saturated_fatty_acids_1: "", //총 포화 지방산(%)
    linoleic_acid: "", //리놀레산(18:2(n-6)c)(㎎)
    alpha_linolenic_acid: "", //알파 리놀렌산(18:3(n-3))(㎎)
    eicosadienoic_acid: "", //에이코사디에노산(20:2(n-6))(㎎)
    omega_3_fatty_acids: "", //오메가 3 지방산(g)
    omega_6_fatty_acids: "", //오메가 6 지방산(g)
    choline: "", //콜린(㎎)
    tryptophan: "", //트립토판(㎎)
    arginine: "", //아르기닌(㎎)
    cysteine: "", //시스테인(㎎)
    taurine: "", //타우린(㎎)
    gamma_linolenic_acid: "", //감마 리놀렌산(18:3(n-6))(㎎)
    arachidonic_acid: "", //아라키돈산(20:4(n-6))(㎎)
    docosahexaenoic_acid: "", //도코사헥사에노산(22:6(n-3))(㎎)
    trans_fatty_acids: "", //트랜스 지방산(g)
    caffeine: "", //카페인
    chrome: "", //크롬(μg)
    guaranteed: "", //보장균수(억CFU)
    lutein: "", //루테인(mg)
    zeaxanthin: "", //지아잔틴
    astaxanthin: "", //아스타잔틴(mg)
    silymarin: "", //실리마린(mg)
    coq10: "", //CoQ10(mg)
    ginsenoside: "", //진세노사이드(mg)
    flavonoids: "", //플라보노이드(mg)
    theanine: "", //테아닌(mg)
    collagen: "", //콜라겐(mg)
    l_lysine: "", //L-라이신
    l_arginine: "", //L-아르기닌(mg)
    inositol: "", //이노시톨(mg)
    octacosanol: "", //옥타코사놀(mg)
    hca: "", //HCA(mg)
    udca: "", //UDCA(mg)
    y_oryzanol: "", //γ-오리자놀
    glucosamine: "", //글루코사민(mg)
    betaglucan: "", //베타글루칸
    brewersyeast: "", //맥주효모(mg)
    oroticacidhydrate: "", //오로트산수화물
    hyaluronic_acid: "", //히알루론산(mg)
    glutamic_acid: "", //폴리감마글루탐산(mg)
    msm: "", //MSM(mg)
    total_anthocyanosides: "", //총 안토시아노사이드(mg)
    alpha_s_1_casein: "", //알파에스1카제인(mg)
    cultured_cells: "", //열처리배양균체(수)
    rosabine: "", //로사빈(mg)
    lauric_acid: "", //쏘팔메토-로르산(mg)
    linolenic_acid: "", //감마리놀렌산(mg)
    catechins: "", //녹차추출물(카테킨)(mg)
    lactulose: "", //락추로스(mg)
    γ_oryzanol: "", //감마-오리자놀(mg)
    woman_proba: "", //보장균수(억CFU)
    bcaa: "", //BCAA(mg)
    aloe: "", //안트라퀴논계화합물(mg)
    corosol: "", //코로솔산(mg)
    flavonol: "", //은행잎추출물-플라보놀배당체(mg)
    monacholine: "", //총 모나콜린K(mg)
    dieckol: "", //디엑콜(mg)
    lactoferrin: "", //락토페린(mg)
    glabridin: "", //Glabridin(mg)
    glutathione: "", //글루타치온(mg)
    carnitine: "", //카르니틴(mg)
    enzyme: "", //효소(mg)
    prebiotics: "", //올리고당(mg)
    hyaluron: "", //히알루론산(mg)
    // Niacin: '',			                   	  //나이아신(mg NE)사용
  });
  const [nutrientsAllergy, setNutrientsAllergy] = useState({
    target_type: 3,
    milk: 0, //우유
    bean: 0, //대두
    sulfurous_acid: 0, //아황산
    beef: 0, //소고기
    mackerel: 0, //고등어
    squid: 0, //오징어
    pork: 0, //돼지고기
    peanut: 0, //땅콩
    wheat: 0, //밀
    buckwheat: 0, //메밀
    crab: 0, //게
    tomato: 0, //토마토
    peach: 0, //복숭아
    clam: 0, //조개류(홍합)
    shrimp: 0, //새우
    egg: 0, //알류(계란)
    chicken: 0, //닭고기
    nuts: 0, //견과류
  });
  const [productKpi, setProductKpi] = useState({
    target_type: 3,
    target: 99,
    unit: 0,
  });
  const [relatedProductList, setRelatedProductList] = useState([]);
  const [category1, setCategory1] = useState([]);
  const [category2, setCategory2] = useState([]);
  const [category3, setCategory3] = useState([]);
  const [categoryOption, setCategoryOption] = useState({
    category1: { category_level: 1, category_parent: "0" },
    category2: { category_level: 2, category_parent: "" },
    category3: { category_level: 3, category_parent: "" },
  });
  const [nutrientCategoryList, setNutrientCategoryList] = useState({
    vitamin: [],
    mineral: [],
    nutrition: [],
  });
  const [nutrientSearchOption, setNutrientSearchOption] = useState({
    standard_content: [],
    additional_ingredient: [],
    effect: [],
  });
  const [selectNutrients, setSelectNutrients] = useState([]);
  const [sellerList, setSellerList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [productAdditionalEx1Cnt, setProductAdditionalEx1Cnt] = useState(0);
  const [productAdditionalEx2Cnt, setProductAdditionalEx2Cnt] = useState(0);
  const [productNameCnt, setProductNameCnt] = useState(0);
  const [options, setOptions] = useState({
    // 노출 요소 설정
    exposure_tag: [],

    product_type: "",
    ref_product_detail: false,
    // 의료기기
    approval_number: true,
    medical_rated_voltage: true,
    medical_power_consumption: true,

    // 가공식품
    product_nutrient: true,

    // 생활화학제품 & 살생물제품
    importer: true,

    cancellation_information: 1,
    cancellation_impossible_information: 1,
    quality_assurance_standards_information: 1,
    refund_indemnity_informaion: 1,
    dispute_information: 1,

    // 상품속성
    gender: 0,
    target_age: 99,
    pregnant: false,

    saving_point: true,
    review_point: true,
    share_point: true,

    // 기타
    product_seller: 0,
    selectNutrientUnit: "",
  });
  const [productImg, setProductImg] = useState({
    main: {},
    remainder: [],
  });
  const [deletedImageUid, setDeletedImageUid] = useState([]);
  const [productDescriptionImg, setProductDescriptionImg] = useState([]);
  const [refProductDescriptionImg, setRefProductDescriptionImg] = useState([]);
  const [deletedImgCount, setDeletedImgCount] = useState({
    main: 0,
    remainder: 0,
    description: 0,
  });
  // const [productExplainImg, setProductExplainImg] = useState({
  // 	Image: [],
  // });
  const [clickImageUid, setClickImageUid] = useState("");
  const [isExplainProductModalOpen, setIsExplainProductModalOpen] =
    useState(false);
  const [isRelatedProductModalOpen, setIsRelatedProductModalOpen] =
    useState(false);
  const [searchOptions, setSearchOptions] = useState({
    product_id: 0,
    product_maker_name: "",
    product_name: "",
    product_brand_name: "",
  });
  const [relatedProduct, setRelatedProduct] = useState({
    recommend_reason: "",
  });
  const [productItemList, setProductItemList] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [orderBy, setOrderBy] = useState("desc");
  const [orderType, setOrderType] = useState("created_at");
  const [error, setError] = useState("");

  const displayOptions = [
    { label: "판매", value: true },
    { label: "미판매", value: false },
  ];
  const displayAtHome = [
    { label: "노출  ", value: true },
    { label: "미노출", value: false },
  ];
  const applyOptions = [
    { label: "적용", value: true },
    { label: "미적용", value: false },
  ];
  const exposureOptions = [
    { label: "노출", value: false },
    { label: "미노출", value: true },
  ];
  const exposureInfoOptions = [
    { label: "BEST", value: "best" },
    { label: "NEW", value: "new" },
  ];
  const productTypeItems = [
    { label: "의료기기", value: 0 },
    { label: "화장품", value: 1 },
    { label: "가공식품", value: 2 },
    { label: "건강기능식품", value: 3 },
    { label: "생활화학제품", value: 4 },
    { label: "살생물제품", value: 5 },
    { label: "기타", value: 6 },
  ];
  const inputOptions = [
    { label: "직접입력", value: true },
    { label: "해당사항 없음", value: false },
  ];
  const formulationItems = [
    { label: "정제", value: "정제" },
    { label: "작은 정제", value: "작은 정제" },
    { label: "캡슐", value: "캡슐" },
    { label: "작은 캡슐", value: "작은 캡슐" },
    { label: "환", value: "환" },
    { label: "분말", value: "분말" },
    { label: "츄어블", value: "츄어블" },
    { label: "액상", value: "액상" },
    { label: "필름", value: "필름" },
    { label: "혼합", value: "혼합" },
    { label: "젤리", value: "젤리" },
    { label: "발포형", value: "발포형" },
    { label: "스프레이", value: "스프레이" },
  ];
  const genderItems = [
    { label: "성별무관", value: 0 },
    { label: "남성", value: 1 },
    { label: "여성", value: 2 },
  ];
  const targetAgeItems = [
    { label: "0~2세", value: 0 },
    { label: "2~13세", value: 1 },
    { label: "0~13세", value: 2 },
    { label: "청소년", value: 3 },
    { label: "청소년부터 성인까지", value: 4 },
    { label: "성인", value: 5 },
    { label: "전 연령", value: 6 },
    // {label: "성인 여성", value: 7},
    // {label: "성인 남성", value: 8},
    { label: "50세 이상", value: 9 },
    // {label: "50세 이상 남성", value: 10},
    // {label: "50세 이상 여성", value: 11},
    // {label: "임산부", value: 12},
    { label: "추전 정보 없음", value: 99 },
  ];
  const forPersonUnitItems = [
    { label: "g", value: "g" },
    { label: "ml", value: "ml" },
    { label: "듀얼포", value: "듀얼포" },
    { label: "방울", value: "방울" },
    { label: "병", value: "병" },
    { label: "분사", value: "분사" },
    { label: "정", value: "정" },
    { label: "정제", value: "정제" },
    { label: "캡슐", value: "캡슐" },
    { label: "포", value: "포" },
    { label: "회", value: "회" },
  ];
  const allergyItems = [
    { label: "우유", value: "milk" },
    { label: "대두", value: "bean" },
    { label: "아황산", value: "sulfurous_acid" },
    { label: "소고기", value: "beef" },
    { label: "고등어", value: "mackerel" },
    { label: "오징어", value: "squid" },
    { label: "돼지고기", value: "pork" },
    { label: "땅콩", value: "peanut" },
    { label: "밀", value: "wheat" },
    { label: "메밀", value: "buckwheat" },
    { label: "게", value: "crab" },
    { label: "토마토", value: "tomato" },
    { label: "복숭아", value: "peach" },
    { label: "조개류(홍합)", value: "clam" },
    { label: "새우", value: "shrimp" },
    { label: "알류(계란)", value: "egg" },
    { label: "닭고기", value: "chicken" },
    { label: "견과류", value: "nuts" },
  ];
  const courierCompanyItems = [
    { label: "한진택배", value: "한진택배" },
    { label: "CJ대한통운", value: "CJ대한통운" },
    { label: "우체국택배", value: "우체국택배" },
    { label: "롯데택배", value: "롯데택배" },
    { label: "로젠택배", value: "로젠택배" },
    { label: "홈픽", value: "홈픽" },
    { label: "GS25 편의점택배(CVSnet)", value: "GS25 편의점택배(CVSnet)" },
    { label: "CU 편의점택배", value: "CU 편의점택배" },
    { label: "경동택배", value: "경동택배" },
    { label: "대신택배", value: "대신택배" },
    { label: "일양로지스", value: "일양로지스" },
    { label: "합동택배", value: "합동택배" },
    { label: "건영택배", value: "건영택배" },
    { label: "천일택배", value: "천일택배" },
    { label: "한덱스", value: "한덱스" },
    { label: "한의사랑택배", value: "한의사랑택배" },
    { label: "EMS", value: "EMS" },
    { label: "TNT Express", value: "TNT Express" },
    { label: "UPS", value: "UPS" },
    { label: "Fedex", value: "Fedex" },
    { label: "USPS", value: "USPS" },
    { label: "i-Parcel", value: "i-Parcel" },
    { label: "DHL Global Mail", value: "DHL Global Mail" },
    { label: "LX판토스", value: "LX판토스" },
    { label: "GSMNtoN", value: "GSMNtoN" },
    { label: "ECMS Express", value: "ECMS Express" },
    { label: "KGL네트웍스", value: "KGL네트웍스" },
    { label: "굿투럭", value: "굿투럭" },
    { label: "우리택배(구 호남택배)", value: "우리택배(구 호남택배)" },
    { label: "GSI Express", value: "GSI Express" },
    { label: "SLX택배", value: "SLX택배" },
    { label: "우리한방택배", value: "우리한방택배" },
    { label: "세방", value: "세방" },
    { label: "Cway Express", value: "Cway Express" },
    { label: "YJS글로벌(영국)", value: "YJS글로벌(영국)" },
    { label: "성원글로벌카고", value: "성원글로벌카고" },
    { label: "홈이노베이션로지스", value: "홈이노베이션로지스" },
    { label: "은하쉬핑", value: "은하쉬핑" },
    { label: "Giant Network Group", value: "Giant Network Group" },
    { label: "FLF퍼레버택배", value: "FLF퍼레버택배" },
    { label: "농협택배", value: "농협택배" },
    { label: "YJS글로벌(월드)", value: "YJS글로벌(월드)" },
    { label: "디디로지스", value: "디디로지스" },
    { label: "대림통운", value: "대림통운" },
    { label: "LOTOS CORPORATION", value: "LOTOS CORPORATION" },
    { label: "애니트랙", value: "애니트랙" },
    { label: "성훈물류", value: "성훈물류" },
    { label: "IK물류", value: "IK물류" },
    { label: "제니엘시스템", value: "제니엘시스템" },
    { label: "스마트로지스", value: "스마트로지스" },
    { label: "이투마스(ETOMARS)", value: "이투마스(ETOMARS)" },
    { label: "풀앳홈", value: "풀앳홈" },
    { label: "프레시솔루션", value: "프레시솔루션" },
    { label: "큐런택배", value: "큐런택배" },
    { label: "두발히어로", value: "두발히어로" },
    { label: "하이브시티", value: "하이브시티" },
    { label: "오늘의픽업", value: "오늘의픽업" },
    { label: "팬스타국제특송(PIEX)", value: "팬스타국제특송(PIEX)" },
    { label: "지니고당일배송", value: "지니고당일배송" },
    { label: "로지스밸리", value: "로지스밸리" },
    { label: "롯데국제특송", value: "롯데국제특송" },
    { label: "나은물류", value: "나은물류" },
    { label: "한샘서비스원 택배", value: "한샘서비스원 택배" },
    { label: "배송하기좋은날(SHIPNERGY)", value: "배송하기좋은날(SHIPNERGY)" },
    { label: "NDEX KOREA", value: "NDEX KOREA" },
    { label: "도도플렉스(dodoflex)", value: "도도플렉스(dodoflex)" },
    { label: "브릿지로지스㈜", value: "브릿지로지스㈜" },
    { label: "허브넷로지스틱스", value: "허브넷로지스틱스" },
    { label: "MEXGLOBAL", value: "MEXGLOBAL" },
    { label: "A.C.E EXPRESS INC", value: "A.C.E EXPRESS INC" },
    { label: "썬더히어로", value: "썬더히어로" },
    { label: "1004홈", value: "1004홈" },
    { label: "㈜캐나다쉬핑", value: "㈜캐나다쉬핑" },
    { label: "부릉", value: "부릉" },
    { label: "YUNDA EXPRESS", value: "YUNDA EXPRESS" },
    { label: "발렉스 특수물류", value: "발렉스 특수물류" },
    { label: "파테크해운항공", value: "파테크해운항공" },
    { label: "핑퐁", value: "핑퐁" },
    { label: "바바바(bababa)", value: "바바바(bababa)" },
    { label: "BAIMA EXPRESS", value: "BAIMA EXPRESS" },
    { label: "엔티엘피스", value: "엔티엘피스" },
    { label: "LTL", value: "LTL" },
    { label: "GTS 로지스", value: "GTS 로지스" },
    { label: "㈜올타코리아", value: "㈜올타코리아" },
    { label: "판월드로지스틱㈜", value: "판월드로지스틱㈜" },
    { label: "큐익스프레스", value: "큐익스프레스" },
    { label: "UFO로지스", value: "UFO로지스" },
    { label: "딜리래빗", value: "딜리래빗" },
    { label: "지오피", value: "지오피" },
    { label: "에이치케이홀딩스", value: "에이치케이홀딩스" },
    { label: "HTNS", value: "HTNS" },
    { label: "DHL", value: "DHL" },
    { label: "라스트마일", value: "라스트마일" },
    { label: "인터로지스", value: "인터로지스" },
    { label: "탱고앤고", value: "탱고앤고" },
    { label: "직구문", value: "직구문" },
    { label: "투데이", value: "투데이" },
    { label: "큐브플로우(CUBEFLOW)", value: "큐브플로우(CUBEFLOW)" },
    { label: "현대글로비스", value: "현대글로비스" },
    { label: "국제로지스틱(KSE)", value: "국제로지스틱(KSE)" },
    { label: "에스더쉬핑", value: "에스더쉬핑" },
    { label: "ARGO", value: "ARGO" },
    { label: "골드스넵스", value: "골드스넵스" },
    { label: "GNG(자이언트)", value: "GNG(자이언트)" },
    { label: "㈜엠티인터내셔널", value: "㈜엠티인터내셔널" },
  ];
  const deliveryDueItems = [
    { label: "1일", value: 1 },
    { label: "2일", value: 2 },
    { label: "3일", value: 3 },
    { label: "4일", value: 4 },
    { label: "5일", value: 5 },
    { label: "6일", value: 6 },
    { label: "7일", value: 7 },
  ];
  const deliveryTypeItems = [
    { label: "당일 배송", value: "당일 배송" },
    { label: "국내 배송", value: "국내 배송" },
    { label: "브랜드사 배송", value: "브랜드사 배송" },
    { label: "당영한 무료배송", value: "당영한 무료배송" },
  ];
  const usabilityOptions = [
    { label: "가능", value: true },
    { label: "불가능", value: false },
  ];
  const paymentsOptions = [
    { label: "지급", value: true },
    { label: "미지급", value: false },
  ];
  const pointBenefitUnits = [
    { label: "원", value: 0 },
    { label: "%", value: 1 },
  ];
  const rowSelection = {
    type: "radio",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };
  const columns = [
    {
      title: "상품번호",
      width: 65,
      dataIndex: "product_id",
      key: "product_id",
      ellipsis: true,
      fixed: "left",
      // sorter: (a, b) => {},
    },
    {
      title: "카테고리",
      width: 80,
      dataIndex: "product_category_name",
      key: "product_category_name",
      ellipsis: true,
      render: (value) => {
        if (value === "") {
          return <span>-</span>;
        } else {
          return value;
        }
      },
    },
    {
      title: "브랜드명",
      width: 130,
      dataIndex: "product_brand_name",
      key: "product_brand_name",
      ellipsis: true,
    },
    {
      title: "상품명",
      width: 150,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
  ];

  useEffect(() => {
    getNutrientList();
    getSellerList();
    if (match.params.hasOwnProperty("id")) {
      getProductInfo();
    } else {
      getCategoryList(categoryOption.category1);
    }
  }, [match.params.id]);

  useEffect(() => {
    if (options.product_seller !== 0) {
      getBrandList();
    }
  }, [options.product_seller]);

  useEffect(() => {
    readProductList();
  }, [orderType, orderBy]);

  const getCategoryList = async (param) => {
    setIsLoading(true);
    try {
      const res = await productApi.readCategoryList(param);
      if (res.code === 200) {
        if (param.category_level === 1) {
          setCategory1(res.result);
          setCategory2([]);
          setCategory3([]);
        } else if (param.category_level === 2) {
          setCategory2(res.result);
          setCategory3([]);
        } else if (param.category_level === 3) {
          setCategory3(res.result);
        }
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getCategoryList read error", error);
    }
  };

  const getNutrientSearchOption = async (nutrientsId) => {
    setIsLoading(true);
    try {
      const res = await nutrientsApi.readNutrientSearchOption(nutrientsId);
      if (res.code === 200) {
        setNutrientSearchOption({
          ...nutrientSearchOption,
          standard_content: res.result.nutrientStandardContentList,
          additional_ingredient: res.result.nutrientAdditionalIngredientList,
          effect: res.result.nutrientEffectList,
        });
      } else {
        throw `선택한 카테고리에 해당하는 검색 조건을 가져오기 못했습니다. 다시 시도해주시길 바랍니다.`;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getNutrientSearchOption read error", error);
      alert(error);
    }
  };

  const getNutrientList = async () => {
    setIsLoading(true);
    try {
      const res = await productApi.readNutrientList();
      if (res.code === 200) {
        setNutrientCategoryList(res.result);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getNutrientList read error", error);
    }
  };

  const getSellerList = async () => {
    setIsLoading(true);
    try {
      const param = {
        userId: user.id === 724 ? 1 : user.id,
      };
      const res = await productApi.readSellerList(param);
      if (res.code === 200) {
        setSellerList(res.result);
      } else {
        alert("정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getSellerList read error", error);
    }
  };

  const getBrandList = async () => {
    setIsLoading(true);
    try {
      const res = await productApi.readBrandList(options.product_seller);
      if (res.code === 200) {
        setBrandList(res.result);
      } else {
        alert("getBrandList 정상적인 요청이 아닙니다.");
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getBrandList read error", error);
    }
  };

  const getProductInfo = async () => {
    setIsLoading(true);
    try {
      const categoryListRes = await productApi.readAllCategoryList();
      const NutrientsListRes = await productApi.readNutrientList();
      const res = await productApi.readProduct(
        match.params.id,
        user.id === 724 ? 1 : user.id,
      );
      if (
        res.code === 200 &&
        categoryListRes.code === 200 &&
        NutrientsListRes.code === 200
      ) {
        // console.log("res.result", res.result);
        setProductInfo(
          res.result,
          categoryListRes.result,
          NutrientsListRes.result,
        );
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getProductInfo read error", error);
    }
  };

  const readProductList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await productApi.readProductListAll(
          0,
          "",
          "",
          "",
          "created_at",
          "desc",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await productApi.readProductListAll(
          searchOptions.product_id,
          searchOptions.product_maker_name,
          searchOptions.product_name,
          searchOptions.product_brand_name,
          orderType,
          orderBy,
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        setProductItemList(res.result);
        setIsLoading(false);
      } else {
        setIsLoading(false);
        alert("정상적인 요청이 아닙니다.");
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("readProductList read error", error);
    }
  };

  const s3Upload = async (file, idx, nutrientsId, name) => {
    // let fileType = file.type.split("/")[1]
    let currIdx = `${idx}`;
    let s3Path = "";
    if (name === "main") {
      s3Path = `image/recommend/${nutrientsId}.jpg`;
    } else if (name === "additional") {
      s3Path = `image/productMain/${nutrientsId}_main_${currIdx}.jpg`;
    } else {
      s3Path = `image/productDetail/${nutrientsId}_detail_${currIdx}.jpg`;
    }
    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: file,
    };
    const res = await plutusS3.putObject(params).promise();
    return res.success === true;
  };

  const s3DeleteList = async (nutrientsId, name) => {
    let deleteList;
    if (name === "additional") {
      const deleteArray = Array.from(
        { length: deletedImgCount.remainder },
        (value, i) => i + 1,
      );
      deleteList = deleteArray.map((deleteIdx) => {
        const s3Path = `image/productMain/${nutrientsId}_main_${deleteIdx}.jpg`;
        return { Key: s3Path };
      });
    } else {
      const deleteArray = Array.from(
        { length: deletedImageUid.length },
        (value, i) => i + 1,
      );
      deleteList = deleteArray.map((deleteIdx) => {
        const s3Path = `image/productDetail/${nutrientsId}_detail_${deleteIdx}.jpg`;
        return { Key: s3Path };
      });
    }
    const deleteParams = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Delete: {
        Objects: deleteList,
        Quiet: false,
      },
    };
    const res = await plutusS3.deleteObjects(deleteParams).promise();
    return res.success === true;
  };

  const handleDeletedImageUid = (uid) => {
    setDeletedImageUid([...deletedImageUid, ...uid]);
  };

  const s3Delete = async (nutrientsId, deleteIdx) => {
    let deleteParams = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: `image/productDetail/${nutrientsId}_detail_${deleteIdx}.jpg`,
    };

    const res = await plutusS3.deleteObject(deleteParams).promise();
    return res.success === true;
  };

  const s3Copy = async (refIdx, newIdx, nutrientsId) => {
    let currIdx = `${refIdx + 1}`;
    let changeIdx = `${newIdx + 1}`;
    const s3Path = `/image/productDetail/${nutrientsId}_detail_${currIdx}.jpg`;

    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      CopySource: process.env.REACT_APP_S3_BUCKETNAME + s3Path,
      Key: `image/productDetail/${nutrientsId}_detail_${changeIdx}-temp.jpg`,
    };

    let res = await plutusS3.copyObject(params).promise();

    let deleteParams = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: `image/productDetail/${nutrientsId}_detail_${currIdx}.jpg`,
    };
    let rsp = await plutusS3.deleteObject(deleteParams).promise();

    return res.success === true && rsp.success === true;
  };

  const s3ReCopy = async (newIdx, nutrientsId) => {
    let changeIdx = `${newIdx + 1}`;
    const s3Path = `/image/productDetail/${nutrientsId}_detail_${changeIdx}-temp.jpg`;

    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      CopySource: process.env.REACT_APP_S3_BUCKETNAME + s3Path,
      Key: `image/productDetail/${nutrientsId}_detail_${changeIdx}.jpg`,
    };

    let res = await plutusS3.copyObject(params).promise();

    let deleteParams = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: `image/productDetail/${nutrientsId}_detail_${changeIdx}-temp.jpg`,
    };
    let rsp = await plutusS3.deleteObject(deleteParams).promise();

    return res.success === true && rsp.success === true;
  };

  const saveProduct = async () => {
    const valid = validation();
    if (valid) {
      let swalResult = true;
      if (user.role === "super_admin") {
        const swalText = `[${product.product_brand_name}] ${
          product.product_name
        } 의\n포인트 정책은 아래와 같습니다.\n구매 확정: ${
          options.saving_point
            ? `${product.saving_point}${
                product.saving_point_type === 0 ? "원" : "%"
              } 지급`
            : "미지급"
        }\n리뷰 작성: ${
          options.review_point
            ? `\n텍스트 리뷰 ${product.review_point}${
                product.review_point_type === 0 ? "원" : "%"
              } / 이미지 첨부 ${product.review_image_point}${
                product.review_image_point_type === 0 ? "원" : "%"
              } 지급`
            : "미지급"
        }\n공유: ${
          options.share_point ? `${product.share_point}원 지급` : "미지급"
        }\n${match.params.hasOwnProperty("id") ? "수정" : "등록"}하시겠습니까?`;
        swalResult = await Swal.fire({
          title: swalText,
          customClass: "custom-alert",
          confirmButtonColor: "#117ffa",
          confirmButtonText: "확인",
          showCancelButton: true,
          cancelButtonText: "돌아가기",
        }).then(async ({ isConfirmed }) => {
          return isConfirmed;
        });
      }
      if (swalResult) {
        setIsLoading(true);
        try {
          let addProduct = {
            description_image_num: productDescriptionImg?.length,
            additional_image_num: productImg.remainder?.length,
          };
          let addProductDetail = {};
          let addProductOption = [];
          let addProductKpi = {};
          for (const key in options) {
            if (
              key === "approval_number" ||
              key === "medical_rated_voltage" ||
              key === "medical_power_consumption" ||
              key === "product_nutrient" ||
              key === "importer"
            ) {
              if (!options[key]) {
                addProductDetail[key] = "해당사항 없음";
              }
            } else if (
              key === "cancellation_information" ||
              key === "cancellation_impossible_information" ||
              key === "quality_assurance_standards_information" ||
              key === "refund_indemnity_informaion" ||
              key === "dispute_information"
            ) {
              if (options[key] === 1) {
                switch (key) {
                  case "cancellation_information":
                    addProduct[key] =
                      "전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다.";
                    break;
                  case "cancellation_impossible_information":
                    addProduct[key] =
                      "전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.";
                    break;
                  case "quality_assurance_standards_information":
                    addProduct[key] =
                      "소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.";
                    break;
                  case "refund_indemnity_informaion":
                    addProduct[key] =
                      "주문취소 및 대금의 환불은 당신의 영양제 마이페이지에서 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환 받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연 15%의 지연배상금을 판매자에게 청구할 수 있습니다.";
                    break;
                  case "dispute_information":
                    addProduct[key] =
                      "소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다.";
                    break;
                }
              } else if (options[key] === 2) {
                addProduct[key] = "상품상세 참조";
              }
            } else if (key === "target_age") {
              //임산부 여부
              if (options["pregnant"]) {
                addProduct["product_target"] = 12;
                addProductKpi["target"] = 12;
                addProductKpi["recommend_age"] = 12;
              } else {
                if (options[key] === 5) {
                  if (options["gender"] === 1) {
                    addProduct["product_target"] = 8;
                    addProductKpi["target"] = 8;
                    addProductKpi["recommend_age"] = 8;
                  } else if (options["gender"] === 2) {
                    addProduct["product_target"] = 7;
                    addProductKpi["target"] = 7;
                    addProductKpi["recommend_age"] = 7;
                  } else {
                    addProduct["product_target"] = options[key];
                    addProductKpi["target"] = options[key];
                    addProductKpi["recommend_age"] = options[key];
                  }
                } else if (options[key] === 9) {
                  if (options["gender"] === 1) {
                    addProduct["product_target"] = 11;
                    addProductKpi["target"] = 11;
                    addProductKpi["recommend_age"] = 11;
                  } else if (options["gender"] === 2) {
                    addProduct["product_target"] = 10;
                    addProductKpi["target"] = 10;
                    addProductKpi["recommend_age"] = 10;
                  } else {
                    addProduct["product_target"] = options[key];
                    addProductKpi["target"] = options[key];
                    addProductKpi["recommend_age"] = options[key];
                  }
                } else {
                  addProduct["product_target"] = options[key];
                  addProductKpi["target"] = options[key];
                  addProductKpi["recommend_age"] = options[key];
                }
              }
            } else if (
              key === "saving_point" ||
              key === "review_point" ||
              key === "share_point"
            ) {
              if (!options[key]) {
                addProduct[key] = 0;
              }
            }
          }
          if (product.product_type === 2 || product.product_type === 3) {
            if (!productDetail.hasOwnProperty("is_genetic_modification")) {
              addProductDetail["is_genetic_modification"] = false;
            }
            if (!productDetail.hasOwnProperty("is_imported")) {
              addProductDetail["is_imported"] = false;
            }
          }
          for (const option of productOptions) {
            if (
              option.option_title !== null &&
              option.option_title !== "" &&
              option.price_1 !== "" &&
              option.price_1 !== "0" &&
              option.discount !== "" &&
              option.price_2 !== ""
            ) {
              if (!option.directly_quantity) {
                option["quantity"] = product.quantity;
              }
              // 태그 추가
              const optionToAdd = { ...option };
              // 태그 이름이 있는 경우에만 태그 관련 필드 처리
              if (
                option.tag_name &&
                option.tag_name.trim() !== "" &&
                option.tag_name.trim() !== null
              ) {
                // 색상 코드 유효성 검사
                const bgColor = option.tag_background_color || "#FF8000";
                const textColor = option.tag_text_color || "#FFFFFF";

                if (!bgColor.startsWith("#") || !textColor.startsWith("#")) {
                  throw `옵션 '${option.option_title}'의 색상 코드는 '#'으로 시작해야 합니다.`;
                }

                optionToAdd.tag_name = option.tag_name;
                optionToAdd.tag_background_color = bgColor;
                optionToAdd.tag_text_color = textColor;
              } else {
                // 태그 이름이 없는 경우 모든 태그 관련 필드를 빈 문자열로 설정
                optionToAdd.tag_name = null;
                optionToAdd.tag_background_color = null;
                optionToAdd.tag_text_color = null;
              }
              addProductOption.push(optionToAdd);
            }
          }
          let nutrientsAllergyVertical =
            nutrientInfoTransform("nutrientsAllergy");
          let nutrientsNutrientVertical =
            nutrientInfoTransform("nutrientInfomation");

          // let informations = {};
          // for (let i = 0; i < 6; i++) {
          //     informations[`information_${i + 1}`] = informationList[i] ?? null
          // }

          // home_description 필드들 추가
          let homeDescriptions = {};
          for (let i = 0; i < 2; i++) {
            homeDescriptions[`home_description_${i + 1}`] =
              product[`home_description_${i + 1}`] || null;
          }

          if (match.params.hasOwnProperty("id")) {
            const editProduct = {
              nutrients: nutrients,
              nutrients_nutrient: nutrientInfo,
              nutrientsKpi: { ...productKpi, ...addProductKpi },
              nutrientsAllergy: nutrientsAllergy,
              nutrientInformationVertical: nutrientsNutrientVertical,
              nutrientsAllergyVertical: nutrientsAllergyVertical,
              productItemMaster: {
                ...product,
                ...addProduct,
                ...homeDescriptions,
                // ...informations,
                delivery_price: sellerList[0]?.delivery_price,
                commission_rate: product.commission_rate
                  ? product.commission_rate
                  : 0,
                commission_rate_2: product.commission_rate_2
                  ? product.commission_rate_2
                  : 0,
                commission_rate_3: product.commission_rate_3
                  ? product.commission_rate_3
                  : 0,
                reviewRefId: selectedReviewProduct?.product_id,
              },
              productItemDetail: { ...productDetail, ...addProductDetail },
              relatedProductItemList: relatedProductList,
              productItemOptionList: addProductOption,
              idList: deleteOption,
              created_by: user.id === 724 ? 1 : user.id,
            };
            const res = await productApi.editProduct(editProduct);
            if (res.code === 200) {
              const nutrientsId = res.result;
              let resultList = [];

              // 상품메인이미지 수정
              if (productImg.main.hasOwnProperty("originFileObj")) {
                const updateResult = await s3Upload(
                  productImg.main.originFileObj,
                  0,
                  nutrientsId,
                  "main",
                );
                resultList.push(updateResult);
              }

              // 상품추가이미지 수정
              if (productImg.remainder?.length !== 0) {
                // 전체 삭제 후 업로드 진행
                if (deletedImgCount.remainder !== 0) {
                  console.log("상품추가이미지 전체 삭제 후 업로드 진행");
                  const deleteRes = await s3DeleteList(
                    nutrientsId,
                    "additional",
                  );
                  if (deleteRes) {
                    const uploadResult = await Promise.all(
                      productImg.remainder.map(async (img, idx) => {
                        return await s3Upload(
                          img.originFileObj,
                          idx + 1,
                          nutrientsId,
                          "additional",
                        );
                      }),
                    );
                    resultList = [...resultList, ...uploadResult];
                  } else {
                    throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`;
                  }
                } else {
                  // 업로드만 진행
                  if (productImg.remainder[0].hasOwnProperty("originFileObj")) {
                    console.log("상품추가이미지 업로드 진행");
                    const uploadResult = await Promise.all(
                      productImg.remainder.map(async (img, idx) => {
                        return await s3Upload(
                          img.originFileObj,
                          idx + 1,
                          nutrientsId,
                          "additional",
                        );
                      }),
                    );
                    resultList = [...resultList, ...uploadResult];
                  }
                }
              } else {
                if (deletedImgCount.remainder !== 0) {
                  console.log("상품추가이미지 전체 삭제");
                  // s3에 존재하는 파일 전체 삭제
                  const deletedRes = await s3DeleteList(
                    nutrientsId,
                    "additional",
                  );
                  if (deletedRes) {
                    resultList.push(deletedRes);
                  } else {
                    throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`;
                  }
                }
              }

              // 상품상세페이지 수정
              // 수정필요데이터!
              if (productDescriptionImg?.length !== 0) {
                // 삭제
                for (const id of deletedImageUid) {
                  const nameArray = id.split("_");
                  const deleteIdx = Number(nameArray[nameArray.length - 1]);
                  const deletedRes = await s3Delete(nutrientsId, deleteIdx);
                  if (deletedRes) {
                    resultList.push(deletedRes);
                  }
                }

                // 추가 및 복사하기
                let upLoadList = [];
                let reCopyList = [];

                for (let i = productDescriptionImg.length - 1; i >= 0; i--) {
                  const item = productDescriptionImg[i];
                  // 기존 image랑 새로운 image랑 동일한 uid값을 가지고 있는지 확인 (중복인지)
                  const refIdx = refProductDescriptionImg.findIndex(
                    (img) => img.uid === item?.uid,
                  );
                  if (refIdx >= 0) {
                    // 기존 이미지 복사
                    if (refIdx !== i) {
                      const newIdx = i;
                      const copyResult = await s3Copy(
                        refIdx,
                        newIdx,
                        nutrientsId,
                      );
                      reCopyList.push(newIdx);
                      resultList = [...resultList, copyResult];
                    }
                  } else {
                    // 기존에 없는 file 새로 업로드 해야 할 대상들 저장하기
                    upLoadList.push({ item, index: i });
                  }
                }

                reCopyList?.map(async (value) => {
                  await s3ReCopy(value, nutrientsId);
                });
                for (const { item, index } of upLoadList) {
                  const uploadResult = await s3Upload(
                    item.originFileObj,
                    index + 1,
                    nutrientsId,
                  );

                  resultList = [...resultList, uploadResult];
                }
              } else if (productDescriptionImg?.length === 0) {
                // 	// s3에 존재하는 파일 전체 삭제
                console.log("상품상세이미지 전체 삭제");
                const deletedRes = await s3DeleteList(
                  nutrientsId,
                  "description",
                );
                if (deletedRes) {
                  resultList = [...resultList, deletedRes];
                } else {
                  throw `기존 이미지를 삭제하는데 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.`;
                }
                // }
              }

              if (resultList?.length !== 0) {
                if (resultList.every((result) => result)) {
                  setIsLoading(false);
                  alert("해당 상품을 성공적으로 수정했습니다.");
                  history.push(`/product/view`);
                } else {
                  throw `이미지 업로드에 실패하였습니다.`;
                }
              } else {
                setIsLoading(false);
                alert("해당 상품을 성공적으로 수정했습니다.");
                history.push(`/product/view`);
              }
            } else {
              throw `수정된 상품 정보를 저장하는데 실패하였습니다.`;
            }
          } else {
            const newProduct = {
              nutrients: nutrients,
              nutrients_nutrient: nutrientInfo,
              nutrientsKpi: { ...productKpi, ...addProductKpi },
              nutrientsAllergy: nutrientsAllergy,
              nutrientInformationVertical: nutrientsNutrientVertical,
              nutrientsAllergyVertical: nutrientsAllergyVertical,
              productItemMaster: {
                ...product,
                ...addProduct,
                ...homeDescriptions,
                // ...informations,
                delivery_price: sellerList[0]?.delivery_price,
                commission_rate: product.commission_rate
                  ? product.commission_rate
                  : 0,
                commission_rate_2: product.commission_rate_2
                  ? product.commission_rate_2
                  : 0,
                commission_rate_3: product.commission_rate_3
                  ? product.commission_rate_3
                  : 0,
                reviewRefId: selectedReviewProduct?.product_id,
              },
              productItemDetail: { ...productDetail, ...addProductDetail },
              relatedProductItemList: relatedProductList,
              productItemOptionList: addProductOption,
              created_by: user.id === 724 ? 1 : user.id,
            };
            // console.log("newProduct", newProduct.productItemMaster);
            const res = await productApi.createProduct(newProduct);
            if (res.code === 200) {
              const nutrientsId = res.result;
              let resultList = [];
              if (Object.keys(productImg.main)?.length > 0) {
                let result = await s3Upload(
                  productImg.main,
                  1,
                  nutrientsId,
                  "main",
                );
                resultList.push(result);
              }
              if (productImg.remainder?.length !== 0) {
                const uploadResult = await Promise.all(
                  productImg.remainder.map(async (img, idx) => {
                    return await s3Upload(
                      img.originFileObj,
                      idx + 1,
                      nutrientsId,
                      "additional",
                    );
                  }),
                );
                resultList = [...resultList, ...uploadResult];
              }
              if (productDescriptionImg?.length !== 0) {
                const uploadResult = await Promise.all(
                  productDescriptionImg.map(async (img, idx) => {
                    return await s3Upload(
                      img.originFileObj,
                      idx + 1,
                      nutrientsId,
                      "description",
                    );
                  }),
                );
                resultList = [...resultList, ...uploadResult];
              }
              if (resultList.every((result) => result)) {
                setIsLoading(false);
                window.alert("상품 등록이 완료되었습니다.");
                history.push(`/product/view`);
              } else {
                setIsLoading(false);
                window.alert("정상적인 요청이 아닙니다.");
              }
            } else if (res.code === 418) {
              setIsLoading(false);
              let duplication = "";
              for (let i = 0; i < res.result?.length; i++) {
                duplication += `${res.result[i].name}, `;
              }
              window.alert(`중복된 정보가 있습니다. \n [${duplication}]`);
            } else if (res.code === 999) {
              setIsLoading(false);
              window.alert(res.msg);
            } else {
              setIsLoading(false);
              window.alert("정상적인 요청이 아닙니다.");
            }
          }
        } catch (error) {
          setIsLoading(false);
          setError(error);
          console.log("saveProduct save error", error);
          alert(error);
        }
      }
    }
  };

  /**
   * categoru 선택 함수
   */
  const handleCategorySelect = (category) => {
    let searchCategory = {};
    if (category.category_level === 1) {
      searchCategory = {
        category_level: 2,
        category_parent: category.category_id,
      };
      setCategoryOption({
        ...categoryOption,
        category2: searchCategory,
        category3: {},
      });
      setProduct({
        ...product,
        product_category_id: "",
        product_category_name: "",
      });
      getCategoryList(searchCategory);
    } else if (category.category_level === 2) {
      searchCategory = {
        category_level: 3,
        category_parent: category.category_id,
      };
      setCategoryOption({ ...categoryOption, category3: searchCategory });
      setProduct({
        ...product,
        product_category_id: "",
        product_category_name: "",
      });
      getCategoryList(searchCategory);
    } else if (category.category_level === 3) {
      const findVitamin = nutrientCategoryList.vitamin.find(
        (nutrient) => nutrient.nutrient_id === category.category_id,
      );
      if (findVitamin) {
        setProduct({
          ...product,
          product_category_id: category.category_id,
          product_category_name: category.category_name,
          top_nutrient_id: category.category_id,
          top_nutrient_unit: findVitamin.nutrient_unit,
        });
        if (
          selectNutrients.some(
            (selectNutrient) =>
              JSON.stringify(selectNutrient) === JSON.stringify(findVitamin),
          )
        ) {
          /* empty */
        } else {
          setSelectNutrients([...selectNutrients, findVitamin]);
        }
      } else {
        const findMineral = nutrientCategoryList.mineral.find(
          (nutrient) => nutrient.nutrient_id === category.category_id,
        );
        if (findMineral) {
          setProduct({
            ...product,
            product_category_id: category.category_id,
            product_category_name: category.category_name,
            top_nutrient_id: category.category_id,
            top_nutrient_unit: findMineral.nutrient_unit,
          });
          if (
            selectNutrients.some(
              (selectNutrient) =>
                JSON.stringify(selectNutrient) === JSON.stringify(findVitamin),
            )
          ) {
            /* empty */
          } else {
            setSelectNutrients([...selectNutrients, findMineral]);
          }
        } else {
          const findNutrition = nutrientCategoryList.nutrition.find(
            (nutrient) => nutrient.nutrient_id === category.category_id,
          );
          if (findNutrition) {
            setProduct({
              ...product,
              product_category_id: category.category_id,
              product_category_name: category.category_name,
              top_nutrient_id: category.category_id,
              top_nutrient_unit: findNutrition.nutrient_unit,
            });
            if (
              selectNutrients.some(
                (selectNutrient) =>
                  JSON.stringify(selectNutrient) ===
                  JSON.stringify(findVitamin),
              )
            ) {
              /* empty */
            } else {
              setSelectNutrients([...selectNutrients, findNutrition]);
            }
          } else {
            setProduct({
              ...product,
              product_category_id: category.category_id,
              product_category_name: category.category_name,
              top_nutrient_id: null,
              top_nutrient_unit: "",
            });
          }
        }
      }
      setNutrients({ ...nutrients, category: category.category_id });
      if (
        category.category_parent === "vitamin" ||
        category.category_parent === "mineral" ||
        category.category_parent === "nutrition" ||
        category.category_parent === "beauty" ||
        category.category_parent === "red_ginseng" ||
        category.category_parent === "protein"
      ) {
        setProductKpi({
          ...productKpi,
          category: category.category_id,
          top_nutrient_id: category.category_id,
        });
        getNutrientSearchOption(category.category_id);
      } else {
        setProductKpi({ ...productKpi, category: category.category_id });
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "is_purchase") {
      setProduct({
        ...product,
        [name]: value,
        product_status: value ? 1 : 0,
        quantity: value ? product.quantity : 0.5,
      });
    } else if (name === "product_name") {
      setProductNameCnt(value?.length);
      setProduct({
        ...product,
        [name]: value,
        seo_title: `${
          product.product_brand_name ? product.product_brand_name : ""
        } ${value} 효능, 효과, 가격, 부작용, 후기 (${moment().format(
          "YYYY",
        )}) | 당신의 영양제`,
        seo_description: `${
          product.product_brand_name ? product.product_brand_name : ""
        } ${value} 정보, 효과, 효능, 부작용, 가격, 추천, 섭취 시간, 믿을 수 있는 후기를 당신의 영양제에서 확인해보세요!`,
        seo_keywords: `${value} 정보, ${value} 부작용, ${value} 효과, ${value} 가격, ${value} 효능, ${value} 먹는 시간, ${value} 복용시간, ${value} 복용순서, ${value} 구매, ${value} 직구, ${value} 종류, ${value} 사이트, ${value} 갤러리, ${value} 맞춤 영양제, ${value} 영양제 후기, ${value} 영양제 순위, ${value} 영양제 비교`,
      });
      setNutrients({ ...nutrients, name: value });
      setProductKpi({ ...productKpi, name: value });
    } else if (name === "additional_ex_1") {
      setProductAdditionalEx1Cnt(value?.length);
      setProduct({ ...product, [name]: value });
    } else if (name === "additional_ex_2") {
      setProductAdditionalEx2Cnt(value?.length);
      setProduct({ ...product, [name]: value });
    } else if (name === "product_maker_name") {
      setProduct({ ...product, [name]: value });
      setProductKpi({ ...productKpi, maker_name: value });
    } else if (name === "price_1") {
      if (
        value !== null &&
        value !== "" &&
        value !== "0" &&
        product.discount !== null &&
        product.discount !== "" &&
        product.discount !== "0"
      ) {
        setProduct({
          ...product,
          [name]: value,
          price_2: value - value * (product.discount / 100),
        });
      } else {
        setProduct({ ...product, [name]: value, price_2: value });
      }
      if (!product.price_2 || !product.discount) {
        setProduct({ ...product, [name]: value, price_2: value });
      }
      setProductKpi({ ...productKpi, price: value });
    } else if (name === "discount") {
      if (
        value !== null &&
        value !== "" &&
        value !== "0" &&
        product.price_1 !== null &&
        product.price_1 !== "" &&
        product.price_1 !== "0"
      ) {
        setProduct({
          ...product,
          [name]: value,
          price_2: product.price_1 - product.price_1 * (value / 100),
        });
      } else {
        setProduct({ ...product, [name]: value, price_2: "" });
      }
    } else if (name === "quantity") {
      const productOptionList = productOptions.filter(
        (option) => !option.directly_quantity,
      );
      for (const option of productOptionList) {
        option["quantity"] = value;
      }
      const newProductOptionList = productOptions.map((option) => {
        const findOption = productOptionList.find(
          (newOption) => newOption.option_title === option.option_title,
        );
        if (findOption) {
          return findOption;
        } else {
          return option;
        }
      });
      setProduct({ ...product, [name]: value });
      setProductOptions([...newProductOptionList]);
    } else if (
      name === "approval_number" ||
      name === "medical_rated_voltage" ||
      name === "medical_power_consumption" ||
      name === "product_nutrient" ||
      name === "importer"
    ) {
      setOptions({ ...options, [name]: value });
      if (!value) {
        setProductDetail({ ...productDetail, [name]: "" });
      }
    } else if (name === "top_nutrient_content") {
      setProduct({ ...product, [name]: value });
      setProductKpi({ ...productKpi, [name]: parseInt(value) });
    } else if (
      name === "saving_point" ||
      name === "review_point" ||
      name === "review_image_point" ||
      name === "share_point"
    ) {
      // 포인트 지급 여부
      if (typeof value === "boolean") {
        setOptions({ ...options, [name]: value });
        if (!value) {
          if (name === "review_point") {
            setProduct({ ...product, [name]: 0, review_image_point: 0 });
          } else {
            setProduct({ ...product, [name]: 0 });
          }
        }
      } else {
        // 지급 포인트 액수
        if (name === "share_point") {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, "") });
        } else if (name === "saving_point" && product.saving_point_type === 0) {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, "") });
        } else if (name === "review_point" && product.review_point_type === 0) {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, "") });
        } else if (
          name === "review_image_point" &&
          product.review_image_point_type === 0
        ) {
          setProduct({ ...product, [name]: value?.replaceAll(/[^0-9]/g, "") });
        } else {
          setProduct({ ...product, [name]: value });
        }
      }
    } else if (e.target.hasOwnProperty("checked")) {
      // case: checkbox
      const checked = e.target.checked;
      // console.log("handleChange === ", name, value, checked);
      if (checked) {
        if (name === "include_vat") {
          setProduct({ ...product, [name]: checked });
        } else if (
          name === "vitamin" ||
          name === "mineral" ||
          name === "nutrition"
        ) {
          const findNutrient = nutrientCategoryList[name].find(
            (nutrient) => nutrient.nutrient_id === e.target.id,
          );
          if (findNutrient) {
            setSelectNutrients([...selectNutrients, findNutrient]);
          }
          setNutrientInfo({ ...nutrientInfo, [e.target.id]: 0 });
        } else if (name === "nutrient_allergy") {
          setNutrientsAllergy({ ...nutrientsAllergy, [e.target.id]: value });
        } else if (name === "nutrient_effect") {
          if (product[name] === "") {
            setProduct({ ...product, [name]: value });
          } else {
            setProduct({ ...product, [name]: product[name] + "," + value });
          }
        } else if (name === "formulation") {
          setProduct({ ...product, [name]: value });
          setProductKpi({ ...productKpi, [name]: value });
        } else if (name === "gender" || name === "target_age") {
          setOptions({ ...options, [name]: value });
        } else if (name === "pregnant") {
          setOptions({ ...options, [name]: checked });
        } else if (name === "began") {
          setProductKpi({ ...productKpi, [name]: value });
        } else if (name === "nutrient_additional_ingredient") {
          if (product[name] === "") {
            setProduct({ ...product, [name]: value });
          } else {
            setProduct({ ...product, [name]: product[name] + "," + value });
          }
        } else if (name === "ref_product_detail") {
          setOptions({ ...options, [name]: checked });
          let editProductDetail;
          switch (options.product_type) {
            case 0:
              editProductDetail = {
                product_detail_name: value,
                product_model_name: value,
                ad_pre_deliberation: value,
                release_date_same_model: value,
                product_detail_maker: value,
                purpose: value,
                instruction: value,
                caution: value,
                quality_assurance_standards: value,
              };
              if (options.approval_number) {
                editProductDetail["approval_number"] = value;
              }
              if (options.medical_rated_voltage) {
                editProductDetail["medical_rated_voltage"] = value;
              }
              if (options.medical_power_consumption) {
                editProductDetail["medical_power_consumption"] = value;
              }
              break;
            case 1:
              editProductDetail = {
                capacity: value,
                product_specification: value,
                validation_date: value,
                instruction: value,
                product_detail_maker: value,
                maker_country: value,
                importer: value,
                product_substance_information: value,
                food_drag_ministry: value,
                caution: value,
                quality_assurance_standards: value,
              };
              break;
            case 2:
              editProductDetail = {
                product_detail_name: value,
                food_type: value,
                importer: value,
                location: value,
                make_date: value,
                validation_date: value,
                capacity_packaging: value,
                quantity_packaging: value,
                product_substance_information: value,
                caution: value,
              };
              if (options.product_nutrient) {
                editProductDetail["product_nutrient"] = value;
              }
              break;
            case 3:
              editProductDetail = {
                product_detail_name: value,
                food_type: value,
                product_detail_maker: value,
                location: value,
                make_date: value,
                validation_date: value,
                capacity_packaging: value,
                quantity_packaging: value,
                product_substance_information: value,
                product_nutrient: value,
                product_specification: value,
                caution_intake: value,
                not_drug_information: value,
                caution: value,
              };
              break;
            case 4:
              editProductDetail = {
                product_detail_name: value,
                usage_formulation: value,
                make_date: value,
                validation_date: value,
                capacity: value,
                effectiveness: value,
                maker_country: value,
                product_detail_maker: value,
                child_protective_packaging_product: value,
                product_substance_information: value,
                caution: value,
                approval_number: value,
              };
              if (options.importer) {
                editProductDetail["importer"] = value;
              }
              break;
            case 5:
              editProductDetail = {
                product_detail_name: value,
                capacity: value,
                effectiveness: value,
                usage_information: value,
                maker_country: value,
                product_detail_maker: value,
                child_protective_packaging_product: value,
                product_substance_information: value,
                product_hazard_information: value,
                caution: value,
                approval_number: value,
              };
              if (options.importer) {
                editProductDetail["importer"] = value;
              }
              break;
          }
          setProductDetail({ ...productDetail, ...editProductDetail });
        } else if (
          name === "is_genetic_modification" ||
          name === "is_imported"
        ) {
          setProductDetail({ ...productDetail, [name]: checked });
        } else if (
          name === "cancellation_information" ||
          name === "cancellation_impossible_information" ||
          name === "quality_assurance_standards_information" ||
          name === "refund_indemnity_informaion" ||
          name === "dispute_information"
        ) {
          if (value !== 3) {
            setProduct({ ...product, [name]: "" });
          }
          setOptions({ ...options, [name]: value });
        } else {
          setProduct({ ...product, [name]: value });
        }
      } else {
        if (name === "include_vat") {
          setProduct({ ...product, [name]: checked });
        } else if (
          name === "vitamin" ||
          name === "mineral" ||
          name === "nutrition"
        ) {
          const deletedArr = selectNutrients.filter(
            (nutrients) => !(nutrients.nutrient_id === e.target.id),
          );
          setSelectNutrients(deletedArr);
          setNutrientInfo({ ...nutrientInfo, [e.target.id]: 0 });
        } else if (name === "nutrient_allergy") {
          setNutrientsAllergy({ ...nutrientsAllergy, [e.target.id]: 0 });
        } else if (name === "nutrient_effect") {
          let effectList = product[name]
            .split(",")
            .filter((effect) => effect !== value);
          setProduct({ ...product, [name]: effectList.join(",") });
        } else if (name === "gender" || name === "target_age") {
          setOptions({ ...options, [name]: value });
        } else if (name === "pregnant") {
          setOptions({ ...options, [name]: checked });
        } else if (name === "began") {
          setProductKpi({ ...productKpi, [name]: 0 });
        } else if (name === "nutrient_additional_ingredient") {
          let ingredientList = product[name]
            .split(",")
            .filter((ingredient) => ingredient !== value);
          setProduct({ ...product, [name]: ingredientList.join(",") });
        } else if (name === "ref_product_detail") {
          setOptions({ ...options, [name]: checked });
        } else if (
          name === "is_genetic_modification" ||
          name === "is_imported"
        ) {
          setProductDetail({ ...productDetail, [name]: checked });
        } else {
          setProduct({ ...product, [name]: 0 });
        }
      }
    } else if (name.includes("information_" || "home_description_")) {
      // let list = [...informationList];
      // list[name[name?.length - 1] - 1] = value;
      // setInformationList(list);
      // // console.log(name, value);
      setProduct({ ...product, [name]: value });
    } else {
      // if (informationList?.length) {
      //     let param = {
      //         infomation_1: informationList[0] ?? null,
      //         infomation_2: informationList[1] ?? null,
      //         infomation_3: informationList[2] ?? null,
      //         infomation_4: informationList[3] ?? null,
      //         infomation_5: informationList[4] ?? null,
      //         infomation_6: informationList[5] ?? null,
      //     }
      //     setProduct({...product, ...param, [name]: value})
      // } else {
      setProduct({ ...product, [name]: value });
      // }
    }
  };

  const handleProductExposureCheck = (checkValue) => {
    if (checkValue?.length === 2) {
      setProduct({ ...product, is_best: true, is_new: true });
    } else if (checkValue.includes("best")) {
      setProduct({ ...product, is_best: true, is_new: false });
    } else if (checkValue.includes("new")) {
      setProduct({ ...product, is_best: false, is_new: true });
    } else {
      setProduct({ ...product, is_best: false, is_new: false });
    }
    setOptions({ ...options, exposure_tag: checkValue });
  };

  const handleProductDetailChange = (e) => {
    const { name, value } = e.target;
    setProductDetail({ ...productDetail, [name]: value });
  };

  const handleNutrientsChange = (e) => {
    const { name, value } = e.target;
    setNutrients({ ...nutrients, [name]: value });
    if (name === "for_person") {
      setProduct({ ...product, [name]: value });
      setProductKpi({ ...productKpi, [name]: value });
    }
  };

  const handleNutrientInfoChange = (e) => {
    const { name, value } = e.target;
    setNutrientInfo({ ...nutrientInfo, [name]: value });
  };

  const handleProductKpiChange = (e) => {
    const { name, value } = e.target;
    if (name === "unit") {
      setProduct({ ...product, [name]: value });
    }
    setProductKpi({ ...productKpi, [name]: value });
  };

  const handleSelectChange = (value, e) => {
    if (e.id === "product_brand") {
      const findBrand = brandList.find((brand) => brand.id === value);
      if (findBrand) {
        setProduct({
          ...product,
          product_brand_id: findBrand.id,
          product_brand_name: findBrand.brand_name,
          shipment_place: findBrand.shipment_place,
          shipment_place_return_exchange: findBrand.shipment_place,
          cs_number: findBrand.phone,
          as_phone: findBrand.phone,
          seo_title: `${findBrand.brand_name} ${
            product.product_name ? product.product_name : ""
          } 효능, 효과, 가격, 부작용, 후기 (${moment().format(
            "YYYY",
          )}) | 당신의 영양제`,
          seo_description: `${findBrand.brand_name} ${
            product.product_name ? product.product_name : ""
          } 정보, 효과, 효능, 부작용, 가격, 추천, 섭취 시간, 믿을 수 있는 후기를 당신의 영양제에서 확인해보세요!`,
        });
        setNutrients({ ...nutrients, brand_name: findBrand.brand_name });
        setProductKpi({ ...productKpi, brand_name: findBrand.brand_name });
      }
    } else if (e.id === "product_seller") {
      const findSeller = sellerList.find(
        (seller) => seller.seller_id === value,
      );
      if (findSeller) {
        setProduct({
          ...product,
          product_seller_id: findSeller.seller_id,
          product_seller_name: findSeller.seller_name,
        });
      }
      setOptions({ ...options, [e.id]: value });
    } else if (e.id === "product_type") {
      setProduct({ ...product, [e.id]: value });
      if (productDetail.hasOwnProperty("id")) {
        setProductDetail({
          id: productDetail.id,
          product_id: productDetail.product_id,
        });
      } else {
        setProductDetail({});
      }
      setOptions({ ...options, [e.id]: value, ref_product_detail: false });
    }
    // else if (e.id === "formulation") {
    //     setProduct({ ...product, [e.id]: value })
    //     setProductKpi({ ...productKpi, [e.id]: value })
    // } else if (e.id === "target") {
    //     setProduct({ ...product, "product_target": value })
    //     setProductKpi({ ...productKpi, [e.id]: value, "recommend_age": value })
    // }
    else if (e.id === "for_person_unit") {
      setNutrients({ ...nutrients, [e.id]: value });
      setProduct({ ...product, [e.id]: value });
      setProductKpi({ ...productKpi, [e.id]: value });
    } else if (
      e.id === "delivery_company" ||
      e.id === "delivery_company_return_exchange"
    ) {
      setProduct({ ...product, [e.id]: value });
    } else if (e.id === "delivery_due") {
      setProduct({ ...product, [e.id]: value });
    } else if (e.id === "delivery_type") {
      if (value === "당영한 무료배송") {
        setProduct({ ...product, [e.id]: value, delivery_price: 0 });
      } else {
        setProduct({ ...product, [e.id]: value });
      }
    } else if (
      e.id === "saving_point_type" ||
      e.id === "review_point_type" ||
      e.id === "review_image_point_type"
    ) {
      // 적립 포인트 단위 '원'으로 변경시, 입력했던 포인트 값 내림처리 (2025.01.14) - ksb
      if (value === 0) {
        if (e.id === "saving_point_type") {
          setProduct({
            ...product,
            [e.id]: value,
            saving_point: Math.floor(product.saving_point),
          });
        } else if (e.id === "review_point_type") {
          setProduct({
            ...product,
            [e.id]: value,
            review_point: Math.floor(product.review_point),
          });
        } else {
          setProduct({
            ...product,
            [e.id]: value,
            review_image_point: Math.floor(product.review_image_point),
          });
        }
      } else {
        setProduct({ ...product, [e.id]: value });
      }
    } else {
      setOptions({ ...options, [e.id]: value });
    }
  };

  const handleProductSearchOptionChange = (e) => {
    const { name, value } = e.target;
    setSearchOptions({ ...searchOptions, [name]: value });
  };

  const handlePreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  /**
   * Image 업로드
   */
  const handleImageChange = (file, fileList, event, name) => {
    if (name === "main") {
      if (match.params.hasOwnProperty("id")) {
        if (file.status === "removed") {
          setProductImg({ ...productImg, main: {} });
        } else {
          const editFile = {
            uid: file.uid,
            name: file.name,
            status: "done",
            url: URL.createObjectURL(file),
            originFileObj: file,
          };
          setProductImg({ ...productImg, main: editFile });
        }
      } else {
        setProductImg({ ...productImg, main: file });
      }
    } else if (name === "additional") {
      if (fileList?.length > 9) {
        const saveFileList = fileList.slice(0, 9);
        setProductImg({ ...productImg, remainder: saveFileList });
        if (fileList[fileList?.length - 1].uid === file.uid) {
          alert("최대 9개의 파일만 업로드가 가능합니다.");
        }
      } else {
        setProductImg({ ...productImg, remainder: fileList });
      }
    } else {
      const addFiles = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: URL.createObjectURL(file),
        originFileObj: file,
      };
      setProductDescriptionImg((prev) => [...prev, addFiles]);
    }
  };

  /**
   * 영양소 함량 정보 항목 삭제 버튼
   */
  const deleteNutritionInfo = (deleteValue) => {
    const deletedArr = selectNutrients.filter(
      (nutrients) => !(nutrients.nutrient_id === deleteValue.nutrient_id),
    );
    setSelectNutrients(deletedArr);
    setNutrientInfo({ ...nutrientInfo, [deleteValue.nutrient_id]: 0 });
    // delete nutrientInfo[`${deleteValue.nutrient_id}`]
  };

  /**
   * 취소 버튼
   */
  const cancelBtnClick = () => {
    if (
      window.confirm(
        "해당 페이지에서 나가면 지금까지 작성했던 기록들이 전부 사라집니다.\n그래도 나가시겠습니까?",
      )
    ) {
      history.push("/product/view");
    }
  };

  /**
   * 연관 상품 검색
   */
  const handleProductSearch = () => {
    setSelectedRows([]);
    setSelectedRowKeys([]);
    readProductList();
  };

  /**
   * 연관 상품 검색 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      product_id: 0,
      product_maker_name: "",
      product_name: "",
      product_brand_name: "",
    });
    setSelectedRows([]);
    setSelectedRowKeys([]);
    readProductList("initial");
  };

  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        setSelectedRowKeys([record.product_id]);
        setSelectedRows([record]);
      },
    };
  };

  const tableOnChange = (pagination, filters, sorter) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * 연관 상품 삭제
   */
  const handleRelatedProductDelete = async (product) => {
    setIsLoading(true);
    try {
      const removedIdx = relatedProductList.findIndex(
        (relatedProduct) =>
          relatedProduct.related_product_id === product.related_product_id,
      );
      if (removedIdx !== -1) {
        relatedProductList.splice(removedIdx, 1);
      } else {
        throw "삭제한 정보를 다시 불러오지 못했습니다. 페이지를 다시 불러와주시길 바랍니다.";
      }
      // const res = await productApi.deleteRelatedProduct(product.main_product_id, product.related_product_id, user.id)
      // if (res.code === 200) {
      //     const removedIdx = relatedProductList.findIndex((relatedProduct) => relatedProduct.main_product_id === product.main_product_id && relatedProduct.related_product_id === product.related_product_id)
      //     if (removedIdx !== -1) {
      //         relatedProductList.splice(removedIdx, 1)
      //     } else {
      //         throw "삭제한 정보를 다시 불러오지 못했습니다. 페이지를 다시 불러와주시길 바랍니다."
      //     }
      // } else {
      //     throw "해당 연관 상품을 삭제하는데 실패하였습니다.\n다시 시도하거나 관리자에게 문의하시길 바랍니다."
      // }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleRelatedProductDelete delete error", error);
    }
  };

  /**
   * 상품 설명 이미지 확인 Modal Open
   */
  const handleExplainProductModalOpen = () => {
    setClickImageUid(productDescriptionImg[0]?.uid);
    setIsExplainProductModalOpen(true);
  };

  const handleExplainProductModalCancel = () => {
    if (window.confirm("변경 사항이 저장되지 않습니다. 나가시겠습니까?")) {
      setIsExplainProductModalOpen(false);
    }
  };
  /**
   * 상품 설명 이미지 확인 Modal handle ok
   */
  const handleExplainProductModalOk = () => {
    setIsExplainProductModalOpen(false);
  };

  /**
   * 상품 설명 이미지 확인 Modal 저장하기
   */
  const handleExplainProductImageSave = (productExplainImgList) => {
    setIsExplainProductModalOpen(false);
    setProductDescriptionImg(productExplainImgList);
  };

  /**
   * 연관 상품 등록 Modal handle open
   */
  const handleRelatedProductModalOpen = () => {
    setIsRelatedProductModalOpen(true);
    readProductList("initial");
  };

  /**
   * 연관 상품 등록 Modal handle cancel
   */
  const handleRelatedProductModalCancel = () => {
    setSearchOptions({
      product_id: 0,
      product_maker_name: "",
      product_name: "",
      product_brand_name: "",
    });
    setRelatedProduct({ recommend_reason: "" });
    setOrderType("created_at");
    setOrderBy("desc");
    setSelectedRows([]);
    setSelectedRowKeys([]);
    setIsRelatedProductModalOpen(false);
  };

  /**
   * 연관 상품 등록 Modal handle ok
   */
  const handleRelatedProductModalOk = () => {
    try {
      const findAddProductIdx = relatedProductList.findIndex(
        (relatedProduct) =>
          relatedProduct.related_product_id === selectedRowKeys[0],
      );
      if (findAddProductIdx === -1) {
        const addProduct = {
          related_product_id: selectedRowKeys[0],
          recommend_reason: relatedProduct.recommend_reason,
          product_brand_name: selectedRows[0].product_brand_name,
          product_name: selectedRows[0].product_name,
          target_id: selectedRows[0].target_id,
        };
        setRelatedProductList([...relatedProductList, addProduct]);
        setSearchOptions({
          product_id: 0,
          product_maker_name: "",
          product_name: "",
          product_brand_name: "",
        });
        setRelatedProduct({ recommend_reason: "" });
        setOrderType("created_at");
        setOrderBy("desc");
        setSelectedRows([]);
        setSelectedRowKeys([]);
        setIsRelatedProductModalOpen(false);
      } else {
        throw "이미 연관상품에 등록한 상품입니다.\n삭제한 뒤 다시 시도하거나 다른 상품으로 등록해주시길 바랍니다.";
      }
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleRelatedProductModalOk add error", error);
      alert(error);
    }
  };

  /**
   * 옵션 추가
   */
  const addOption = () => {
    setProductOptions([
      ...productOptions,
      {
        option_title: "[N%, 1+1] N박스 (N개월분)",
        price_1: 0,
        price_2: 0,
        discount: 0,
        option_quantity: 1,
        option_description: "",
        option_type: "price",
        quantity: product.quantity,
        directly_quantity: false,
        // 태그 추가
        tag_name: null,
        tag_background_color: null,
        tag_text_color: null,
      },
    ]);
  };

  /**
   * 옵션 삭제
   */
  const deleteOptions = (index, option) => {
    let currList = [...productOptions];
    currList.splice(index, 1);
    if (match.params.hasOwnProperty("id")) {
      if (option.hasOwnProperty("id")) {
        setDeleteOption([...deleteOption, option.id]);
      }
    }
    setProductOptions(currList);
  };

  /**
   * 옵션 handleChange
   */
  const handleOptionChange = (e, index) => {
    const { name, value } = e.target;
    let currOptions = [...productOptions];
    if (name === "discount") {
      if (
        productOptions[index].price_1 !== null &&
        productOptions[index].price_1 !== 0 &&
        value !== "" &&
        value !== "0"
      ) {
        currOptions[index]["price_2"] =
          productOptions[index].price_1 -
          productOptions[index].price_1 * (parseInt(value) / 100);
      } else if (
        productOptions[index].price_1 !== null &&
        productOptions[index].price_1 !== 0 &&
        value !== ""
      ) {
        currOptions[index]["price_2"] = productOptions[index].price_1;
      }
    }
    if (e.target.hasOwnProperty("checked")) {
      const checked = e.target.checked;
      if (!checked) {
        currOptions[index]["quantity"] = product.quantity;
      }
      currOptions[index][name] = checked;
    } else {
      currOptions[index][name] = value;
    }
    setProductOptions(currOptions);
  };

  /**
   * 옵션 handlePriceChange
   */
  const handleOptionPriceChange = (value, name, index) => {
    let currOptions = [...productOptions];
    if (name === "price_1") {
      if (
        productOptions[index].discount !== "" &&
        productOptions[index].discount !== "0" &&
        value !== null &&
        value !== 0
      ) {
        currOptions[index]["price_2"] =
          value - value * (parseInt(productOptions[index].discount) / 100);
      } else if (
        !productOptions[index].discount &&
        value !== null &&
        value !== 0
      ) {
        currOptions[index]["price_2"] = value;
      }
    } else if (name === "price_2") {
      if (
        productOptions[index].price_1 !== null &&
        productOptions[index].price_1 !== 0 &&
        value !== null
      ) {
        currOptions[index]["discount"] = Math.floor(
          ((productOptions[index].price_1 - value) /
            productOptions[index].price_1) *
            100,
        );
      }
    }
    currOptions[index][name] = value;
    setProductOptions(currOptions);
  };

  const validation = () => {
    if (
      typeof product["is_purchase"] === "undefined" ||
      product["is_purchase"] === null ||
      typeof product["is_admin_product"] === "undefined" ||
      product["is_admin_product"] === null ||
      typeof product["product_category_id"] === "undefined" ||
      product["product_category_id"] === null ||
      product["product_category_id"] === "" ||
      typeof product["product_category_name"] === "undefined" ||
      product["product_category_name"] === null ||
      product["product_category_name"] === "" ||
      typeof product["product_name"] === "undefined" ||
      product["product_name"] === null ||
      product["product_name"] === "" ||
      typeof product["product_seller_id"] === "undefined" ||
      product["product_seller_id"] === null ||
      product["product_seller_id"] === "" ||
      typeof product["product_seller_name"] === "undefined" ||
      product["product_seller_name"] === null ||
      product["product_seller_name"] === "" ||
      typeof product["product_brand_id"] === "undefined" ||
      product["product_brand_id"] === null ||
      product["product_brand_id"] === "" ||
      typeof product["product_brand_name"] === "undefined" ||
      product["product_brand_name"] === null ||
      product["product_brand_name"] === "" ||
      typeof product["price_1"] === "undefined" ||
      product["price_1"] === null ||
      typeof product["quantity"] === "undefined" ||
      product["quantity"] === null ||
      Object.keys(productImg.main)?.length === 0 ||
      typeof product["product_type"] === "undefined" ||
      product["product_type"] === null
    ) {
      alert("필수 입력란에 값이 없습니다. 다시 확인해보시고 입력바랍니다.");
      return false;
    } else {
      return true;
    }
  };

  /**
   * 영양제 상품군 선택여부
   */
  const isNutritionalPro = () => {
    if (categoryOption.category3.hasOwnProperty("category_parent")) {
      if (
        categoryOption.category3.category_parent === "vitamin" ||
        categoryOption.category3.category_parent === "mineral" ||
        categoryOption.category3.category_parent === "nutrition" ||
        categoryOption.category3.category_parent === "beauty" ||
        categoryOption.category3.category_parent === "red_ginseng" ||
        categoryOption.category3.category_parent === "protein"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const nutrientInfoTransform = (type) => {
    let result = [];
    if (type === "nutrientInfomation") {
      for (const key in nutrientInfo) {
        if (
          key === "target_type" ||
          key === "id" ||
          key === "target_id" ||
          key === "created_at" ||
          key === "created_by" ||
          key === "created_by_name" ||
          key === "updated_at" ||
          key === "updated_by" ||
          key === "updated_by_name"
        ) {
          /* empty */
        } else {
          result.push({
            target_id: 0,
            target_type: 3,
            nutrient_id: key,
            nutrient_content: nutrientInfo[key],
          });
        }
      }
    } else if (type === "nutrientsAllergy") {
      for (const key in nutrientsAllergy) {
        if (
          key === "target_type" ||
          key === "id" ||
          key === "target_id" ||
          key === "created_at" ||
          key === "created_by" ||
          key === "created_by_name" ||
          key === "updated_at" ||
          key === "updated_by" ||
          key === "updated_by_name"
        ) {
          /* empty */
        } else {
          result.push({
            target_id: 0,
            target_type: 3,
            nutrient_id: key,
            nutrient_allergy: nutrientsAllergy[key],
          });
        }
      }
    }

    return result;
  };

  const setProductInfo = (
    {
      productItemMaster,
      productItemDetail,
      nutrients,
      nutrientsKpi,
      nutrients_nutrient,
      nutrientsAllergy,
      relatedProductItemList,
      productItemOptionList,
    },
    categoryList,
    nutrientsList,
  ) => {
    let editProduct = {};
    let editProductDetail = {};
    let editNutrients = {};
    let editProductKpi = {};
    let editNutrientInfo = {};
    let editNutrientsAllergy = {};
    let editImage = { main: {}, remainder: [], description: [] };
    let editCategoryOption = {};
    let editOptions = {};
    let editSelectNutrients = [];
    let allCategory2 = [];
    let allCategory3 = [];
    const productType = productItemMaster["product_type"];

    // ProductItemMaster setting
    for (const key in productItemMaster) {
      if (key === "product_category_id") {
        getNutrientSearchOption(productItemMaster[key]);
        const findCategory3 = categoryList.level3.find(
          (category) => category.category_id === productItemMaster[key],
        );
        if (findCategory3) {
          editCategoryOption["category3"] = {
            category_level: 3,
            category_parent: findCategory3.category_parent,
          };
          allCategory3 = categoryList.level3.filter(
            (category) =>
              category.category_parent === findCategory3.category_parent,
          );
          const findCategory2 = categoryList.level2.find(
            (category) =>
              category.category_id === findCategory3.category_parent,
          );
          if (findCategory2) {
            editCategoryOption["category2"] = {
              category_level: 2,
              category_parent: findCategory2.category_parent,
            };
            allCategory2 = categoryList.level2.filter(
              (category) =>
                category.category_parent === findCategory2.category_parent,
            );
            const findCategory1 = categoryList.level1.find(
              (category) =>
                category.category_id === findCategory2.category_parent,
            );
            if (findCategory1) {
              editCategoryOption["category1"] = {
                category_level: 1,
                category_parent: "0",
              };
            }
          }
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "product_name") {
        setProductNameCnt(productItemMaster[key]?.length);
        editProduct[key] = productItemMaster[key];
      } else if (key === "product_seller_id") {
        editOptions["product_seller"] = productItemMaster[key];
        editProduct[key] = productItemMaster[key];
      } else if (key === "product_brand_id") {
        if (productItemMaster[key]) {
          editProduct[key] = parseInt(productItemMaster[key]);
        } else {
          editProduct[key] = productItemMaster[key];
        }
      } else if (key === "is_best") {
        if (productItemMaster[key] && productItemMaster["is_new"]) {
          editOptions["exposure_tag"] = ["best", "new"];
        } else if (productItemMaster[key]) {
          editOptions["exposure_tag"] = ["best"];
        } else if (productItemMaster["is_new"]) {
          editOptions["exposure_tag"] = ["new"];
        } else {
          editOptions["exposure_tag"] = [];
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "additional_ex_1") {
        if (productItemMaster[key]) {
          setProductAdditionalEx1Cnt(productItemMaster[key]?.length);
        } else {
          setProductAdditionalEx1Cnt(0);
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "additional_ex_2") {
        if (productItemMaster[key]) {
          setProductAdditionalEx2Cnt(productItemMaster[key]?.length);
        } else {
          setProductAdditionalEx2Cnt(0);
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "product_type") {
        editOptions[key] = productItemMaster[key];
        editProduct[key] = productItemMaster[key];
      } else if (key === "product_target") {
        if (productItemMaster[key] === 12) {
          editOptions["gender"] = 2;
          editOptions["target_age"] = productItemMaster[key];
          editOptions["pregnant"] = true;
        } else {
          editOptions["pregnant"] = false;
          if (productItemMaster[key] === 7 || productItemMaster[key] === 10) {
            editOptions["gender"] = 2;
            editOptions["target_age"] = productItemMaster[key] === 7 ? 5 : 9;
          } else if (
            productItemMaster[key] === 8 ||
            productItemMaster[key] === 11
          ) {
            editOptions["gender"] = 1;
            editOptions["target_age"] = productItemMaster[key] === 8 ? 5 : 9;
          } else {
            editOptions["gender"] = 0;
            editOptions["target_age"] = productItemMaster[key];
          }
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "target_id") {
        // 썸네일 불러오기
        const thumbnail = {
          uid: `${productItemMaster[key]}`,
          name: `${productItemMaster[key]}.jpg`,
          status: "done",
          mode: "s3",
          url: `${process.env.REACT_APP_S3_HOST}/image/recommend/${productItemMaster[key]}.jpg`,
        };
        editImage.main = thumbnail;
        editProduct[key] = productItemMaster[key];
      } else if (key === "additional_image_num") {
        let additionalImgList = [];
        for (let i = 0; i < productItemMaster[key]; i++) {
          const thumbnail = {
            uid: `${productItemMaster["target_id"]}_main_${i + 1}`,
            name: `${productItemMaster["target_id"]}_main_${i + 1}.jpg`,
            status: "done",
            mode: "s3",
            url: `${process.env.REACT_APP_S3_HOST}/image/productMain/${
              productItemMaster["target_id"]
            }_main_${i + 1}.jpg`,
          };
          additionalImgList.push(thumbnail);
        }
        editImage.remainder = additionalImgList;
        editProduct[key] = productItemMaster[key];
      } else if (key === "description_image_num") {
        let descriptionImgList = [];
        for (let i = 0; i < productItemMaster[key]; i++) {
          const thumbnail = {
            uid: `${productItemMaster["target_id"]}_detail_${i + 1}`,
            name: `${productItemMaster["target_id"]}_detail_${i + 1}.jpg`,
            status: "done",
            url: `${process.env.REACT_APP_S3_HOST}/image/productDetail/${
              productItemMaster["target_id"]
            }_detail_${i + 1}.jpg`,
          };
          descriptionImgList.push(thumbnail);
        }
        editImage.description = descriptionImgList;
        editProduct[key] = productItemMaster[key];
      } else if (key === "cancellation_information") {
        if (
          productItemMaster[key] ===
          "전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자 또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일 이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가 부담합니다."
        ) {
          editOptions[key] = 1;
        } else if (productItemMaster[key] === "상품상세 참조") {
          editOptions[key] = 2;
        } else {
          editOptions[key] = 3;
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "cancellation_impossible_information") {
        if (
          productItemMaster[key] ===
          "전자상거래 등에서의 소비자보호에 관한 법률 등에 의한 청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에 준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다."
        ) {
          editOptions[key] = 1;
        } else if (productItemMaster[key] === "상품상세 참조") {
          editOptions[key] = 2;
        } else {
          editOptions[key] = 3;
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "quality_assurance_standards_information") {
        if (
          productItemMaster[key] ===
          "소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다."
        ) {
          editOptions[key] = 1;
        } else if (productItemMaster[key] === "상품상세 참조") {
          editOptions[key] = 2;
        } else {
          editOptions[key] = 3;
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "refund_indemnity_informaion") {
        if (
          productItemMaster[key] ===
          "주문취소 및 대금의 환불은 당신의 영양제 마이페이지에서 신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한 법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환 받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한 사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연 15%의 지연배상금을 판매자에게 청구할 수 있습니다."
        ) {
          editOptions[key] = 1;
        } else if (productItemMaster[key] === "상품상세 참조") {
          editOptions[key] = 2;
        } else {
          editOptions[key] = 3;
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "dispute_information") {
        if (
          productItemMaster[key] ===
          "소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에 따릅니다."
        ) {
          editOptions[key] = 1;
        } else if (productItemMaster[key] === "상품상세 참조") {
          editOptions[key] = 2;
        } else {
          editOptions[key] = 3;
        }
        editProduct[key] = productItemMaster[key];
      } else if (key === "is_available_point") {
        if (!productItemMaster[key]) {
          editOptions["saving_point"] = false;
          editOptions["review_point"] = false;
          editOptions["share_point"] = false;
        }
        editProduct[key] = productItemMaster[key];
      } else if (
        key === "saving_point" ||
        key === "review_point" ||
        key === "share_point"
      ) {
        if (productItemMaster[key] === 0) {
          editOptions[key] = false;
        } else {
          editOptions[key] = true;
        }
        editProduct[key] = productItemMaster[key];
      } else if (
        key === "nutrient_effect" ||
        key === "nutrient_additional_ingredient"
      ) {
        if (!productItemMaster[key]) {
          editProduct[key] = "";
        } else {
          editProduct[key] = productItemMaster[key];
        }
      } else if (
        key === "updated_at" ||
        key === "updated_by" ||
        key === "updated_by_name"
      ) {
        /* empty */
      } else if (key === "reviewRefId") {
        getReviewProduct(productItemMaster[key]);
        editProduct[key] = productItemMaster[key];
      } else {
        editProduct[key] = productItemMaster[key];
      }
    }

    // ProductDetail setting
    if (productItemDetail) {
      for (const key in productItemDetail) {
        if (productItemDetail[key] !== null) {
          switch (productType) {
            // 의료기기
            case 0:
              if (
                key === "approval_number" ||
                key === "medical_rated_voltage" ||
                key === "medical_power_consumption"
              ) {
                if (productItemDetail[key] === "해당사항 없음") {
                  editOptions[key] = false;
                } else {
                  editProductDetail[key] = productItemDetail[key];
                }
              } else if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
            // 화장품
            case 1:
              if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
            // 가공식품
            case 2:
              if (key === "product_nutrient") {
                if (productItemDetail[key] === "해당사항 없음") {
                  editOptions[key] = false;
                } else {
                  editProductDetail[key] = productItemDetail[key];
                }
              } else if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
            // 건강기능식품
            case 3:
              if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
            // 생활화학제품
            case 4:
              if (key === "importer") {
                if (productItemDetail[key] === "해당사항 없음") {
                  editOptions[key] = false;
                } else {
                  editProductDetail[key] = productItemDetail[key];
                }
              } else if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
            // 살생물제품
            case 5:
              if (key === "importer") {
                if (productItemDetail[key] === "해당사항 없음") {
                  editOptions[key] = false;
                } else {
                  editProductDetail[key] = productItemDetail[key];
                }
              } else if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
            default:
              if (
                key === "updated_at" ||
                key === "updated_by" ||
                key === "updated_by_name"
              ) {
                /* empty */
              } else {
                editProductDetail[key] = productItemDetail[key];
              }
              break;
          }
        }
      }
    } else {
      editProductDetail["product_id"] = productItemMaster["product_id"];
    }

    // ProductOption setting
    // console.log("productItemOptionList", productItemOptionList);
    const editProductOption = productItemOptionList.filter(
      (option) => !option.terminated_status,
    );

    // Nutrients setting
    for (const key in nutrients) {
      if (
        key === "id" ||
        key === "intakes_per_day" ||
        key === "num_per_one" ||
        key === "for_person" ||
        key === "take_medicine_time"
      ) {
        editNutrients[key] = nutrients[key];
      }
    }

    // NutrientsKpi setting
    for (const key in nutrientsKpi) {
      if (
        key === "updated_at" ||
        key === "updated_by" ||
        key === "updated_by_name"
      ) {
        /* empty */
      } else {
        editProductKpi[key] = nutrientsKpi[key];
      }
    }

    // NutrientsInformation setting
    for (const key in nutrients_nutrient) {
      if (
        key === "updated_at" ||
        key === "updated_by" ||
        key === "updated_by_name" ||
        key === "total_nutrients_type"
      ) {
        /* empty */
      } else if (key === "id" || key === "target_id" || key === "target_type") {
        editNutrientInfo[key] = nutrients_nutrient[key];
      } else {
        editNutrientInfo[key] = nutrients_nutrient[key];
        if (nutrients_nutrient[key] !== 0) {
          const findVitamin = nutrientsList.vitamin.find(
            (nutrient) => nutrient.nutrient_id === key,
          );
          if (findVitamin) {
            editSelectNutrients.push(findVitamin);
          } else {
            const findMineral = nutrientsList.mineral.find(
              (nutrient) => nutrient.nutrient_id === key,
            );
            if (findMineral) {
              editSelectNutrients.push(findMineral);
            } else {
              const findNutrition = nutrientsList.nutrition.find(
                (nutrient) => nutrient.nutrient_id === key,
              );
              if (findNutrition) {
                editSelectNutrients.push(findNutrition);
              }
            }
          }
        }
      }
    }

    // NutrientsAllergy setting
    for (const key in nutrientsAllergy) {
      if (
        key === "updated_at" ||
        key === "updated_by" ||
        key === "updated_by_name"
      ) {
        /* empty */
      } else {
        editNutrientsAllergy[key] = nutrientsAllergy[key];
      }
    }

    setCategory1(categoryList.level1);
    setCategory2(allCategory2);
    setCategory3(allCategory3);
    setProduct({ ...product, ...editProduct });
    setProductDetail({ ...productDetail, ...editProductDetail });
    setRelatedProductList(relatedProductItemList);
    setProductOptions(
      editProductOption?.length === 0
        ? [
            {
              option_title: "1박스 1개월분",
              price_1: 0,
              price_2: 0,
              discount: 0,
              option_quantity: 1,
              option_description: "",
              option_type: "price",
              quantity: product.quantity,
              directly_quantity: false,
              // 태그 추가
              tag_name: null,
              tag_background_color: null,
              tag_text_color: null,
            },
          ]
        : editProductOption,
    );
    setProductImg({
      ...productImg,
      main: editImage.main,
      remainder: editImage.remainder,
    });
    setProductDescriptionImg(editImage.description);
    setRefProductDescriptionImg(editImage.description);
    setNutrients({ ...nutrients, ...editNutrients });
    setProductKpi({ ...productKpi, ...editProductKpi });
    setNutrientInfo({ ...nutrientInfo, ...editNutrientInfo });
    setNutrientsAllergy({ ...nutrientsAllergy, ...editNutrientsAllergy });
    setSelectNutrients(editSelectNutrients);
    setCategoryOption({ ...categoryOption, ...editCategoryOption });
    setOptions({ ...options, ...editOptions });
  };

  const findBrandInfo = () => {
    if (brandList?.length !== 0 && product.hasOwnProperty("product_brand_id")) {
      const findBrand = brandList.find(
        (brand) => brand.id === product.product_brand_id,
      );
      if (findBrand) {
        return findBrand.basic_commission_rate;
      }
    }
    return 0;
  };

  useEffect(() => {
    if (
      user.role !== "super_admin" &&
      sellerList?.length > 0 &&
      !match.params.id
    ) {
      setOptions({ ...options, product_seller: sellerList[0].seller_id });
      if (brandList?.length > 0) {
        setProduct({
          ...product,
          product_seller_id: sellerList[0].seller_id,
          product_seller_name: sellerList[0].seller_name,
          product_brand_id: brandList[0].id,
          product_brand_name: brandList[0].brand_name,
          shipment_place: brandList[0].shipment_place,
          shipment_place_return_exchange: brandList[0].shipment_place,
          cs_number: brandList[0].phone,
          as_phone: brandList[0].phone,
          seo_title: `${brandList[0].brand_name} ${
            product.product_name ? product.product_name : ""
          } 효능, 효과, 가격, 부작용, 후기 (${moment().format(
            "YYYY",
          )}) | 당신의 영양제`,
          seo_description: `${brandList[0].brand_name} ${
            product.product_name ? product.product_name : ""
          } 정보, 효과, 효능, 부작용, 가격, 추천, 섭취 시간, 믿을 수 있는 후기를 당신의 영양제에서 확인해보세요!`,
        });
        setNutrients({ ...nutrients, brand_name: brandList[0].brand_name });
        setProductKpi({ ...productKpi, brand_name: brandList[0].brand_name });
      }
    }
  }, [match, user, sellerList, brandList]);
  const [exampleShow, setExampleShow] = useState(false);
  const [exampleTitle, setExampleTitle] = useState({
    id: "",
    title: "",
  });

  const handleExampleModal = (e, mainImageId) => {
    const id = e.target.id;
    setExampleShow(true);
    if (id === "exposure") {
      setExampleTitle({
        id: id,
        title: "노출 요소 예시",
      });
    } else if (id === "tag") {
      setExampleTitle({
        id: id,
        title: "노출 요소 예시",
      });
    } else if (id === "option") {
      setExampleTitle({
        id: id,
        title: "옵션 예시",
      });
    } else if (id === "pick") {
      setExampleTitle({
        id: id,
        title: "당영픽 예시",
      });
    } else if (id === "promotion") {
      setExampleTitle({
        id: id,
        title: "프로모션 수수료율 예시",
      });
    } else if (mainImageId === "main-image") {
      setExampleTitle({
        id: mainImageId,
        title: "대표이미지 예시",
      });
    }
  };

  const [isProductSelectModalVisible, setIsProductSelectModalVisible] =
    useState(false);
  const [selectedReviewProduct, setSelectedReviewProduct] = useState(null);

  const handleProductSelect = (selectedProduct) => {
    // console.log("선택된 상품:", selectedProduct);
    setSelectedReviewProduct(selectedProduct);
  };

  const getReviewProduct = async (productId) => {
    try {
      const res = await productApi.readProductList({
        product_id: productId,
        product_maker_name: "",
        product_name: "",
        product_brand_name: "",
        product_status: "total",
        category1: "",
        category2: "",
        category3: "",
        orderType: "created_at",
        orderBy: "desc",
        offset: 0,
        pageSize: 1,
        userId: user.id === 724 ? 1 : user.id,
      });

      if (res.code === 200 && res.result.productItemMasterList.length > 0) {
        const reviewProduct = res.result.productItemMasterList[0];
        setSelectedReviewProduct(reviewProduct);
      }
    } catch (error) {
      console.error("리뷰 참조 상품 조회 실패:", error);
    }
  };

  return (
    <>
      {/*<ContentHeaderComponent title="상품 등록" />*/}
      <ContentHeaderComponent
        title={
          isLoading
            ? null
            : match.params.hasOwnProperty("id")
            ? "상품 수정"
            : "상품 등록"
        }
      />
      <div className="product-register-wrap">
        {/*품절 상태*/}
        <Row
          className="product-register-border-box"
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className="product-register-box-title">품절 상태</span>
          <span className="product-register-box-sign">*</span>
          <Radio.Group
            name="is_purchase"
            options={displayOptions}
            onChange={handleChange}
            value={product.is_purchase}
            className="product-register-purchase-status-wrap"
            optionType="button"
            buttonStyle="solid"
          />
        </Row>
        {/*홈 노출 여부*/}
        <Row
          className="product-register-border-box"
          style={{ marginTop: 20, marginBottom: 18 }}
        >
          <span className="product-register-box-title">홈 노출 여부</span>
          <span className="product-register-box-sign">*</span>
          <Radio.Group
            name="home_display_yn"
            options={displayAtHome}
            onChange={handleChange}
            value={product.home_display_yn}
            className="product-register-purchase-status-wrap"
            optionType="button"
            buttonStyle="solid"
          />
        </Row>

        {/*관리자판매전용상품*/}
        <>
          <Row
            className="product-register-border-box"
            style={{ marginTop: 20, marginBottom: 18 }}
          >
            {user?.role === "super_admin" ? (
              <span className="product-register-box-title">
                관리자판매전용상품
              </span>
            ) : (
              <span className="product-register-box-title">노출여부</span>
            )}
            <span className="product-register-box-sign">*</span>
            <Radio.Group
              name="is_admin_product"
              // options={applyOptions}
              options={exposureOptions}
              onChange={handleChange}
              value={product.is_admin_product}
              className="product-register-purchase-status-wrap"
              optionType="button"
              buttonStyle="solid"
            />
          </Row>
        </>

        {/*카테고리*/}
        <>
          <Row className="product-register-border-box" wrap={false}>
            <span className="product-register-box-title">카테고리</span>
            <span className="product-register-box-sign">*</span>
          </Row>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ borderTop: 0, padding: "30px 33px", height: 300 }}
          >
            <Col className="product-register-category-wrap" span={8}>
              {category1?.length > 0 ? (
                <>
                  {category1.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.category_level}_${categoryItem.category_name}_${idx}`}
                      className={
                        "product-register-category-item-wrap" +
                        (categoryOption.category2.category_parent ===
                        categoryItem.category_id
                          ? " selected"
                          : "")
                      }
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className="product-register-category-name"
                        flex="auto"
                      >
                        {categoryItem.category_name}
                      </Col>
                      <img
                        className="product-register-category-icon"
                        src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-2.png`}
                      />
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
            <Col className="product-register-category-wrap" span={8}>
              {category2?.length > 0 ? (
                <>
                  {category2.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.category_level}_${categoryItem.category_name}_${idx}`}
                      className={
                        "product-register-category-item-wrap" +
                        (categoryOption.category3.category_parent ===
                        categoryItem.category_id
                          ? " selected"
                          : "")
                      }
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className="product-register-category-name"
                        flex="auto"
                      >
                        {categoryItem.category_name}
                      </Col>
                      <img
                        className="product-register-category-icon"
                        src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-2.png`}
                      />
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
            <Col className="product-register-category-wrap" span={8}>
              {category3?.length > 0 ? (
                <>
                  {category3.map((categoryItem, idx) => (
                    <Row
                      key={`${categoryItem.category_level}_${categoryItem.category_name}_${idx}`}
                      className={
                        "product-register-category-item-wrap" +
                        (product.product_category_id ===
                        categoryItem.category_id
                          ? " selected"
                          : "")
                      }
                      wrap={false}
                      onClick={() => handleCategorySelect(categoryItem)}
                    >
                      <Col
                        className="product-register-category-name"
                        flex="auto"
                      >
                        {categoryItem.category_name}
                      </Col>
                    </Row>
                  ))}
                </>
              ) : null}
            </Col>
          </Row>
        </>

        {/*상품명/정보*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">상품명 / 정보</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="product-register-form-input-wrap center-label"
              label="상품명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
              required
            >
              <Input
                name="product_name"
                value={product.product_name}
                maxLength={50}
                onChange={handleChange}
              />
              <div className="product-name-count-wrap">
                <span className="product-name-count">{productNameCnt}</span>/50
              </div>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            {user.role === "super_admin" && (
              <>
                <Form.Item
                  className="center-label"
                  label="판매자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 2 }}
                  wrapperCol={{ span: 6 }}
                  required
                >
                  <Select
                    placeholder="판매자를 선택해주세요."
                    value={
                      options.product_seller !== 0
                        ? options.product_seller
                        : null
                    }
                    onChange={handleSelectChange}
                  >
                    {sellerList?.length > 0 && (
                      <>
                        {sellerList.map((seller, idx) => (
                          <Option
                            key={`seller_${idx}`}
                            id="product_seller"
                            value={seller.seller_id}
                          >
                            {seller.seller_name}
                          </Option>
                        ))}
                      </>
                    )}
                  </Select>
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}
            <Form.Item
              className="center-label"
              label="브랜드명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 6 }}
              required
            >
              <Select
                placeholder="브랜드를 선택해주세요."
                value={
                  brandList?.length !== 0 ? product.product_brand_id : null
                }
                onChange={handleSelectChange}
              >
                {brandList?.length !== 0 && (
                  <>
                    {brandList.map((brand, idx) => (
                      <Option
                        key={`brand_${idx}`}
                        id="product_brand"
                        value={brand.id}
                      >
                        {brand.brand_name}
                      </Option>
                    ))}
                  </>
                )}
              </Select>
            </Form.Item>
            {/*<Divider className="product-register-form-input-divider"/>*/}
            {/*<Form.Item*/}
            {/*    className="center-label"*/}
            {/*    label="제조사명"*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{span: 2}}*/}
            {/*    wrapperCol={{span: 6}}*/}
            {/*>*/}
            {/*    <Input name="product_maker_name" value={product.product_maker_name} onChange={handleChange}*/}
            {/*           placeholder="제조사를 입력해주세요."/>*/}
            {/*</Form.Item>*/}
          </div>
        </>

        {/* 리뷰 참조 상품 */}
        <Row
          className="product-register-border-box"
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <span className="product-register-box-title">리뷰 참조 상품</span>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "25px 25px",
            height: "fit-content",
          }}
        >
          <Button
            type="primary"
            onClick={() => setIsProductSelectModalVisible(true)}
          >
            리뷰 참조 상품 선택
          </Button>

          {selectedReviewProduct && (
            <div
              style={{
                marginTop: 16,
                padding: 16,
                border: "1px solid #f0f0f0",
                borderRadius: 4,
              }}
            >
              <h4>선택된 리뷰 참조 상품</h4>
              <div style={{ display: "flex", gap: 16 }}>
                <div>상품번호: {selectedReviewProduct.product_id}</div>
                <div>상품명: {selectedReviewProduct.product_name}</div>
                <div>브랜드: {selectedReviewProduct.product_brand_name}</div>
                <div>
                  판매가: {selectedReviewProduct.price_1?.toLocaleString()}원
                </div>
                <Button
                  type="text"
                  danger
                  onClick={() => setSelectedReviewProduct(null)}
                >
                  × 삭제
                </Button>
              </div>
            </div>
          )}
          <Col
            flex="none"
            className="product-price-help"
            style={{ marginTop: 10 }}
          >
            *해당 상품의 리뷰가 당영몰 리뷰에 조회됩니다.
          </Col>
        </div>

        <ProductReviewRefComponent
          visible={isProductSelectModalVisible}
          onClose={() => setIsProductSelectModalVisible(false)}
          onSelect={handleProductSelect}
          currentProductId={product.product_id}
          selectedReviewProduct={selectedReviewProduct}
        />

        {/*판매가*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">판매가</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="product-register-form-input-wrap center-label"
              label="판매가"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 8 }}
              required
            >
              <Input
                type="number"
                name="price_1"
                value={product.price_1}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">원</span>}
              />
              <Col flex="none" className="product-price-help">
                *정가를 입력해주세요.
              </Col>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-form-input-wrap center-label"
              label="할인률"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 9 }}
            >
              <Input
                type="number"
                name="discount"
                value={product.discount}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">%</span>}
              />
              <Col flex="none" className="product-price-help">
                *할인 할 퍼센트를 입력해주세요.
              </Col>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-form-input-wrap center-label"
              label="할인가"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 11 }}
            >
              <Input
                type="number"
                name="price_2"
                value={product.price_2}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">원</span>}
              />
              <Col flex="none" className="product-price-help">
                *할인가를 할인률을 적용하여 계산 후 입력해주세요.
              </Col>
            </Form.Item>
            {/*<Divider className="product-register-form-input-divider"/>*/}
            {/*<Form.Item*/}
            {/*    label="최저가"*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{span: 2}}*/}
            {/*    wrapperCol={{span: 22}}*/}
            {/*>*/}
            {/*    <Row wrap={false} gutter={8} className="product-option-text" style={{marginBottom: 15}}>*/}
            {/*        <Col span={4}>가격</Col>*/}
            {/*        <Col span={3}>할인률</Col>*/}
            {/*        <Col span={7}>기준정보</Col>*/}
            {/*    </Row>*/}
            {/*    <Row wrap={false} gutter={8} className="product-option-row-wrap">*/}
            {/*        <Col span={4}>*/}
            {/*            <InputNumber*/}
            {/*                formatter={(value) => value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}*/}
            {/*                parser={(value) => value.replace(/\$\s?|(,*)/g, '')}*/}
            {/*                min={0}*/}
            {/*                value={product.low_price}*/}
            {/*                onChange={(value) => handleChange({target: {name: "low_price", value: value}})}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col span={3}>*/}
            {/*            <Input*/}
            {/*                type="number"*/}
            {/*                min={0}*/}
            {/*                name="low_discount"*/}
            {/*                value={product.low_discount}*/}
            {/*                onChange={handleChange}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*        <Col span={7}>*/}
            {/*            <Input*/}
            {/*                name="low_standard"*/}
            {/*                placeholder="ex. 7+4 뱍스 당 기준"*/}
            {/*                value={product.low_standard}*/}
            {/*                onChange={handleChange}*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*</Form.Item>*/}
          </div>
        </>

        {/*재고수량*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">재고수량</span>
            <span className="product-register-box-sign">*</span>
          </Row>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item wrapperCol={{ span: 16 }} required>
              <Input
                type="number"
                name="quantity"
                value={product.quantity}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">개</span>}
                disabled={!product.is_purchase}
              />
            </Form.Item>
          </Row>
        </>

        {/*노출 요소 설정*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">노출 요소 설정</span>
            <span
              className="product-register-box-subtitle"
              style={{
                fontSize: "0.9rem",
                cursor: "pointer",
                borderBottom: "solid 1px #117ffa",
              }}
              id={"tag"}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              label="태그"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              {user?.role === "super_admin" && (
                <>
                  <Checkbox.Group
                    className="product-exposure-checkbox-wrap"
                    options={exposureInfoOptions}
                    value={options.exposure_tag}
                    onChange={handleProductExposureCheck}
                  />
                  <div
                    className="product-exposure-help-text"
                    style={{ marginTop: 24, marginBottom: 10 }}
                  >
                    직접입력
                  </div>
                </>
              )}
              <Row>
                <Input
                  className="product-exposure-tag-input"
                  name="exposure_tag_1"
                  value={product.exposure_tag_1}
                  onChange={handleChange}
                />
                <Input
                  className="product-exposure-tag-input"
                  name="exposure_tag_2"
                  value={product.exposure_tag_2}
                  onChange={handleChange}
                />
                <Input
                  className="product-exposure-tag-input"
                  name="exposure_tag_3"
                  value={product.exposure_tag_3}
                  onChange={handleChange}
                />
                <Col
                  flex="none"
                  className="product-exposure-right-text"
                  style={{ marginLeft: 6 }}
                >
                  선택 태그 포함 합산 최대 12글자
                </Col>
              </Row>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="최저가격"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 6 }}
            >
              <Input
                name="lowest_price"
                value={product.lowest_price}
                onChange={handleChange}
              />
              <div
                className="product-exposure-help-text"
                style={{ marginTop: 12 }}
              >
                ex. 개당 2,400원 ~
              </div>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="추가설명"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              <Row>
                <Col span={7}>
                  <Input
                    maxLength={15}
                    name="additional_ex_1"
                    value={product.additional_ex_1}
                    onChange={handleChange}
                    style={{ marginBottom: 10 }}
                  />
                </Col>
                <Col
                  flex="none"
                  className="product-exposure-right-text"
                  style={{ marginBottom: 10 }}
                >
                  {productAdditionalEx1Cnt}/15
                </Col>
              </Row>
              <Row>
                <Col span={7}>
                  <Input
                    maxLength={15}
                    name="additional_ex_2"
                    value={product.additional_ex_2}
                    onChange={handleChange}
                  />
                </Col>
                <Col flex="none" className="product-exposure-right-text">
                  {productAdditionalEx2Cnt}/15
                </Col>
              </Row>
            </Form.Item>
          </div>
        </>
        {/* 홈 상품 메인 설명 */}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">
              홈 상품 메인 설명
            </span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            {/*{informationList?.map((item, idx) => (*/}
            {Array.from({ length: 2 })?.map((item, idx) => (
              <Form.Item
                className="product-register-form-input-wrap"
                label={`특징 ${idx + 1}`}
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
                style={{
                  position: "relative",
                }}
              >
                <Input.TextArea
                  name={`home_description_${idx + 1}`}
                  value={product[`home_description_${idx + 1}`]}
                  onChange={handleChange}
                  style={{
                    minHeight: "50px",
                  }}
                />
              </Form.Item>
            ))}
          </div>
        </>

        {/*옵션*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">옵션</span>
            <span
              className="product-register-box-subtitle"
              style={{
                fontSize: "0.9rem",
                cursor: "pointer",
                borderBottom: "solid 1px #117ffa",
              }}
              id={"option"}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 40px",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="product-option-wrap"
              label={`옵션 목록(${productOptions?.length}개)`}
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              <div className="product-option-list-wrap">
                {productOptions.map((option, index) => {
                  if (index === 0) {
                    return (
                      <div key={`product-option-${index}`}>
                        <Row
                          wrap={false}
                          gutter={8}
                          className="product-option-text"
                          style={{ marginBottom: 15 }}
                          // key={`product-option-${index}`}
                        >
                          <Col flex="none">
                            <div
                              className="product-option-button-wrap"
                              style={{
                                width: "auto",
                                minWidth: "auto",
                              }}
                            />
                          </Col>
                          <Col span={3} style={{ textAlign: "center" }}>
                            옵션 번호
                          </Col>
                          <Col span={5} style={{ textAlign: "center" }}>
                            옵션명
                          </Col>
                          <Col span={3} style={{ textAlign: "center" }}>
                            판매가
                          </Col>
                          <Col span={2} style={{ textAlign: "center" }}>
                            할인률
                          </Col>
                          <Col span={3} style={{ textAlign: "center" }}>
                            할인가
                          </Col>
                          <Col span={2} style={{ textAlign: "center" }}>
                            구매 수량
                          </Col>
                          {/*<Col span={2}>개별 수량</Col>*/}
                          {/*<Col span={3}>재고</Col>*/}
                          <Col span={5} style={{ textAlign: "center" }}>
                            옵션 설명
                          </Col>
                          <Col span={5} style={{ textAlign: "center" }}>
                            혜택 안내
                          </Col>
                          <Col span={2} style={{ textAlign: "center" }}>
                            미노출
                          </Col>
                          {/* 태그 */}
                          <Col span={8} style={{ textAlign: "center" }}>
                            옵션 태그
                          </Col>
                          {/* 태그 끝 */}
                        </Row>
                        <Row
                          wrap={false}
                          gutter={8}
                          className="product-option-row-wrap"
                        >
                          <Col flex="none" style={{ textAlign: "end" }}>
                            <div
                              className="product-option-button-wrap"
                              style={{
                                width: "auto",
                                minWidth: "auto",
                              }}
                            >
                              {/*        {((productOptions?.length - 1) === index) ?*/}
                              {/*            <Button*/}
                              {/*                className="product-option-button"*/}
                              {/*                icon={<img style={{width: "100%", height: "100%"}}*/}
                              {/*                           src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-add.png`}/>}*/}
                              {/*                onClick={addOption}*/}
                              {/*                style={{marginRight: 10}}*/}
                              {/*            ></Button>*/}
                              {/*            : null}*/}
                              {productOptions?.length !== 1 ? (
                                <img
                                  className="product-option-button"
                                  style={{
                                    width: "22px",
                                    height: "22px",
                                    cursor: "pointer",
                                  }}
                                  src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}
                                  onClick={() => deleteOptions(index, option)}
                                />
                              ) : null}
                            </div>
                          </Col>
                          <Col span={3} style={{ textAlign: "center" }}>
                            <Input
                              readOnly={true}
                              name="option_number"
                              value={
                                option?.product_id && option?.id
                                  ? `${option.product_id}_${option.id}`
                                  : ""
                              }
                              disabled={true}
                            />
                          </Col>
                          <Col span={5}>
                            <Input
                              name="option_title"
                              placeholder="옵션명을 입력해주세요."
                              value={option.option_title}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={3}>
                            <InputNumber
                              formatter={(value) =>
                                value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, "")
                              }
                              min={0}
                              value={option.price_1}
                              onChange={(value) =>
                                handleOptionPriceChange(value, "price_1", index)
                              }
                            />
                          </Col>
                          <Col span={2}>
                            <Input
                              type="number"
                              min={0}
                              name="discount"
                              value={option.discount}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={3}>
                            <InputNumber
                              formatter={(value) =>
                                value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                              }
                              parser={(value) =>
                                value.replace(/\$\s?|(,*)/g, "")
                              }
                              min={0}
                              value={option.price_2}
                              onChange={(value) =>
                                handleOptionPriceChange(value, "price_2", index)
                              }
                            />
                          </Col>
                          <Col span={2}>
                            <Input
                              type="number"
                              min={1}
                              name="option_quantity"
                              value={option.option_quantity}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          {/*<Col span={2}>*/}
                          {/*    <Checkbox*/}
                          {/*        className="product-option-checkbox"*/}
                          {/*        name="directly_quantity"*/}
                          {/*        checked={option.directly_quantity}*/}
                          {/*        value={true}*/}
                          {/*        onChange={(e) => handleOptionChange(e, index)}*/}
                          {/*    />*/}
                          {/*</Col>*/}
                          {/*<Col span={3}>*/}
                          {/*    <Input*/}
                          {/*        type="number"*/}
                          {/*        min={0}*/}
                          {/*        name="quantity"*/}
                          {/*        value={option.quantity}*/}
                          {/*        disabled={!option.directly_quantity}*/}
                          {/*        onChange={(e) => handleOptionChange(e, index)}*/}
                          {/*    />*/}
                          {/*</Col>*/}
                          <Col span={5}>
                            <Input
                              name="option_description"
                              placeholder="옵션 설명을 입력해주세요"
                              value={option.option_description}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={5}>
                            <Input
                              name="option_benefit"
                              placeholder="혜택 설명을 입력해주세요"
                              value={option.option_benefit}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>
                          <Col span={2}>
                            <Checkbox
                              className="product-option-checkbox"
                              name="is_admin"
                              checked={option.is_admin}
                              value={true}
                              onChange={(e) => handleOptionChange(e, index)}
                            />
                          </Col>

                          {/* 태그 추가 */}
                          <Col span={8}>
                            <Row gutter={[8, 0]}>
                              <Col span={8}>
                                <Input
                                  name="tag_name"
                                  placeholder="태그 이름"
                                  value={option.tag_name}
                                  onChange={(e) => handleOptionChange(e, index)}
                                />
                              </Col>
                              <Col
                                span={8}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <Input
                                  type="color"
                                  value={option.tag_background_color}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  name="tag_background_color"
                                  title="배경색 선택"
                                  style={{
                                    width: "24px",
                                    padding: 0,
                                    height: "24px",
                                  }}
                                />
                                <Input
                                  value={option.tag_background_color}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  name="tag_background_color"
                                  placeholder="옵션 배경색"
                                  style={{ flex: 1 }}
                                />
                              </Col>
                              <Col
                                span={8}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <Input
                                  type="color"
                                  value={option.tag_text_color}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  name="tag_text_color"
                                  title="글자색 선택"
                                  style={{
                                    width: "24px",
                                    padding: 0,
                                    height: "24px",
                                  }}
                                />
                                <Input
                                  value={option.tag_text_color}
                                  onChange={(e) => handleOptionChange(e, index)}
                                  name="tag_text_color"
                                  placeholder="옵션 글자색"
                                  style={{ flex: 1 }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    );
                  } else {
                    return (
                      <Row
                        wrap={false}
                        gutter={8}
                        className="product-option-row-wrap"
                        key={`product-option-${index}`}
                      >
                        <Col flex="none" style={{ textAlign: "end" }}>
                          <div
                            className="product-option-button-wrap"
                            style={{
                              width: "auto",
                              minWidth: "auto",
                            }}
                          >
                            {/*        {((productOptions?.length - 1) === index) ?*/}
                            {/*            <Button*/}
                            {/*                className="product-option-button"*/}
                            {/*                icon={<img style={{width: "100%", height: "100%"}}*/}
                            {/*                           src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-add.png`}/>}*/}
                            {/*                onClick={addOption}*/}
                            {/*                style={{marginRight: 10}}*/}
                            {/*            ></Button>*/}
                            {/*            : null}*/}
                            {productOptions?.length !== 1 ? (
                              <img
                                className="product-option-button"
                                style={{
                                  width: "22px",
                                  height: "22px",
                                  cursor: "pointer",
                                }}
                                src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}
                                onClick={() => deleteOptions(index, option)}
                              />
                            ) : null}
                          </div>
                        </Col>
                        <Col span={3} style={{ textAlign: "center" }}>
                          <Input
                            readOnly={true}
                            name="option_number"
                            value={
                              option?.product_id && option?.id
                                ? `${option.product_id}_${option.id}`
                                : ""
                            }
                            disabled={true}
                          />
                        </Col>
                        <Col span={5}>
                          <Input
                            name="option_title"
                            placeholder="옵션명을 입력해주세요."
                            value={option.option_title}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>
                        <Col span={3}>
                          <InputNumber
                            formatter={(value) =>
                              value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                            min={0}
                            value={option.price_1}
                            onChange={(value) =>
                              handleOptionPriceChange(value, "price_1", index)
                            }
                          />
                        </Col>
                        <Col span={2}>
                          <Input
                            type="number"
                            min={0}
                            name="discount"
                            value={option.discount}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>
                        <Col span={3}>
                          <InputNumber
                            formatter={(value) =>
                              value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }
                            parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
                            min={0}
                            value={option.price_2}
                            onChange={(value) =>
                              handleOptionPriceChange(value, "price_2", index)
                            }
                          />
                        </Col>
                        <Col span={2}>
                          <Input
                            type="number"
                            min={1}
                            name="option_quantity"
                            value={option.option_quantity}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>
                        {/*<Col span={2}>*/}
                        {/*    <Checkbox*/}
                        {/*        className="product-option-checkbox"*/}
                        {/*        name="directly_quantity"*/}
                        {/*        checked={option.directly_quantity}*/}
                        {/*        value={true}*/}
                        {/*        onChange={(e) => handleOptionChange(e, index)}*/}
                        {/*    />*/}
                        {/*</Col>*/}
                        {/*<Col span={3}>*/}
                        {/*    <Input*/}
                        {/*        type="number"*/}
                        {/*        min={0}*/}
                        {/*        name="quantity"*/}
                        {/*        value={option.quantity}*/}
                        {/*        disabled={!option.directly_quantity}*/}
                        {/*        onChange={(e) => handleOptionChange(e, index)}*/}
                        {/*    />*/}
                        {/*</Col>*/}
                        <Col span={5}>
                          <Input
                            name="option_description"
                            placeholder="옵션 설명을 입력해주세요"
                            value={option.option_description}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>
                        <Col span={5}>
                          <Input
                            name="option_benefit"
                            placeholder="혜택 설명을 입력해주세요"
                            value={option.option_benefit}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>
                        <Col span={2}>
                          <Checkbox
                            className="product-option-checkbox"
                            name="is_admin"
                            checked={option.is_admin}
                            value={true}
                            onChange={(e) => handleOptionChange(e, index)}
                          />
                        </Col>

                        {/* 태그 추가 */}
                        <Col span={8}>
                          <Row gutter={[8, 0]}>
                            <Col span={8}>
                              <Input
                                name="tag_name"
                                placeholder="태그 이름"
                                value={option.tag_name}
                                onChange={(e) => handleOptionChange(e, index)}
                              />
                            </Col>
                            <Col
                              span={8}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <Input
                                type="color"
                                value={option.tag_background_color}
                                onChange={(e) => handleOptionChange(e, index)}
                                name="tag_background_color"
                                title="배경색 선택"
                                style={{
                                  width: "24px",
                                  padding: 0,
                                  height: "24px",
                                }}
                              />
                              <Input
                                value={option.tag_background_color}
                                onChange={(e) => handleOptionChange(e, index)}
                                name="tag_background_color"
                                placeholder="옵션 배경색"
                                style={{ flex: 1 }}
                              />
                            </Col>
                            <Col
                              span={8}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <Input
                                type="color"
                                value={option.tag_text_color}
                                onChange={(e) => handleOptionChange(e, index)}
                                name="tag_text_color"
                                title="글자색 선택"
                                style={{
                                  width: "24px",
                                  padding: 0,
                                  height: "24px",
                                }}
                              />
                              <Input
                                value={option.tag_text_color}
                                onChange={(e) => handleOptionChange(e, index)}
                                name="tag_text_color"
                                placeholder="옵션 글자색"
                                style={{ flex: 1 }}
                              />
                            </Col>
                          </Row>
                        </Col>
                        {/* 태그 끝 */}
                      </Row>
                    );
                  }
                })}
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "fit-content",
                  margin: "1rem auto",
                  cursor: "pointer",
                }}
                onClick={addOption}
              >
                <img
                  style={{ width: "16px", height: "16px", marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-add.png`}
                  className="product-option-button"
                  onClick={addOption}
                />
                <p style={{ margin: 0 }}>옵션추가</p>
              </div>
            </Form.Item>
          </div>
        </>

        {/*당영지수 */}
        <div style={{ display: "none" }}>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">당영지수</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 40px",
              height: "fit-content",
            }}
          >
            <Row>
              <Form.Item
                className="product-register-kpi-title-wrap"
                label="브랜드지수"
                labelAlign="left"
                colon={false}
                style={{ paddingRight: 20 }}
              >
                <Input
                  type="number"
                  name="brand_famous_kpi"
                  value={productKpi.brand_famous_kpi}
                  min={0}
                  onChange={handleProductKpiChange}
                />
              </Form.Item>
              <Form.Item
                className="product-register-kpi-title-wrap"
                label="판매량지수"
                labelAlign="left"
                colon={false}
              >
                <Input
                  type="number"
                  name="sales_kpi"
                  value={productKpi.sales_kpi}
                  min={0}
                  onChange={handleProductKpiChange}
                />
              </Form.Item>
            </Row>
            <Divider className="product-register-form-input-divider" />
            <div className="product-register-kpi-title-wrap">
              <label>전문가지수</label>
              <span>* 전문가지수 = (제조사+브랜드사+댓글관리+후기만족)/4</span>
            </div>
            <Row>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="제조사"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="maker_kpi"
                    value={productKpi.maker_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">+</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="브랜드사"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="brand_kpi"
                    value={productKpi.brand_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">+</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="댓글관리"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="comment_kpi"
                    value={productKpi.comment_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">+</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="후기만족"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="feedback_kpi"
                    value={productKpi.feedback_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">/4=</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap total-kpi-label"
                  label="전문가지수"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="expert_kpi"
                    value={productKpi.expert_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider className="product-register-form-input-divider" />
            <div className="product-register-kpi-title-wrap">
              <label>품질지수</label>
              <span>* 품질지수 = (원료+함량+부원료+포장)/4</span>
            </div>
            <Row>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="원료"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="material_kpi"
                    value={productKpi.material_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">+</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="함량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="content_kpi"
                    value={productKpi.content_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">+</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="부원료"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="sub_material_kpi"
                    value={productKpi.sub_material_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">+</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap"
                  label="포장"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="pack_kpi"
                    value={productKpi.pack_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
              <span className="product-register-kpi-sign">/4=</span>
              <Col span={3}>
                <Form.Item
                  className="product-register-kpi-item-wrap total-kpi-label"
                  label="품질지수"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                >
                  <Input
                    type="number"
                    name="quality_kpi"
                    value={productKpi.quality_kpi}
                    min={0}
                    onChange={handleProductKpiChange}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </div>
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">당영픽</span>
            <span
              className="product-register-box-subtitle"
              style={{
                fontSize: "0.9rem",
                cursor: "pointer",
                borderBottom: "solid 1px #117ffa",
              }}
              id={"pick"}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="product-register-form-input-wrap"
              label="메인 특징"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              <Input name="usp" value={product.usp} onChange={handleChange} />
            </Form.Item>
            {/*{informationList?.map((item, idx) => (*/}
            {Array.from({ length: 6 })?.map((item, idx) => (
              <Form.Item
                className="product-register-form-input-wrap"
                label={`특징 ${idx + 1}`}
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
                style={{
                  position: "relative",
                }}
              >
                {/*{(informationList?.length > 4) && (*/}
                {/*    <img*/}
                {/*        className="product-option-button"*/}
                {/*        style={{*/}
                {/*            width: "22px",*/}
                {/*            height: "22px",*/}
                {/*            cursor: "pointer",*/}
                {/*            position: "absolute",*/}
                {/*            top: 0,*/}
                {/*            left: "-3%"*/}
                {/*        }}*/}
                {/*        src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-delete.png`}*/}
                {/*        onClick={() => handleInformationList("delete", idx)}*/}
                {/*    />*/}
                {/*)}*/}
                <Input.TextArea
                  name={`information_${idx + 1}`}
                  value={product[`information_${idx + 1}`]}
                  onChange={handleChange}
                  style={{
                    minHeight: "50px",
                  }}
                />
              </Form.Item>
            ))}
            {/*{(informationList?.length >= 4 && informationList?.length < 6) && (*/}
            {/*    <div style={{*/}
            {/*        display: "flex",*/}
            {/*        alignItems: "center",*/}
            {/*        justifyContent: "center",*/}
            {/*        width: "fit-content",*/}
            {/*        margin: "1rem auto",*/}
            {/*        cursor: "pointer"*/}
            {/*    }}*/}
            {/*         onClick={() => handleInformationList("add")}*/}
            {/*    >*/}
            {/*        <img style={{width: "16px", height: "16px", marginRight: 5}}*/}
            {/*             src={`${process.env.REACT_APP_HOST}/assets/images/product/product-option-add.png`}*/}
            {/*             className="product-option-button"*/}
            {/*        />*/}
            {/*        <p style={{margin: 0}}>*/}
            {/*            특징추가*/}
            {/*        </p>*/}
            {/*    </div>*/}
            {/*)}*/}
          </div>
        </>

        {/*브랜드 프로모션 수수료율*/}
        <div style={{ display: "none" }}>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">
              브랜드 수수료율 (VAT 별도)
            </span>
          </Row>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item wrapperCol={{ span: 16 }}>
              {findBrandInfo() + "%"}
            </Form.Item>
          </Row>
        </div>

        {/*당영투게더 인플루언서 수수료율 - 프로모션 수수료율*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">
              프로모션 수수료율 (VAT 별도)
            </span>
            <span
              className="product-register-box-subtitle"
              style={{
                fontSize: "0.9rem",
                cursor: "pointer",
                borderBottom: "solid 1px #117ffa",
              }}
              id={"promotion"}
              onClick={handleExampleModal}
            >
              예시
            </span>
          </Row>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item wrapperCol={{ span: 16 }}>
              <p>HELLO</p>
              <Input
                type="number"
                name="commission_rate_3"
                value={product.commission_rate_3}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">%</span>}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 16 }}>
              <p>FAMILY</p>
              <Input
                type="number"
                name="commission_rate_2"
                value={product.commission_rate_2}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">%</span>}
              />
            </Form.Item>
            <Form.Item wrapperCol={{ span: 16 }}>
              <p>PREMIUM</p>
              <Input
                type="number"
                name="commission_rate"
                value={product.commission_rate}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">%</span>}
              />
            </Form.Item>
          </Row>
        </>

        {/*상품이미지*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">상품이미지</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              label="대표이미지"
              labelAlign="left"
              tooltip={{
                id: "main-image",
                title: false,
                trigger: "click",
                onClick: (e) => {
                  handleExampleModal(e, "main-image");
                },
              }}
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
              required
            >
              {match.params.hasOwnProperty("id") ? (
                <Upload
                  className="product-register-upload-img-wrap"
                  // action="/upload.do"
                  listType="picture-card"
                  maxCount={1}
                  fileList={
                    Object.keys(productImg.main)?.length !== 0
                      ? [productImg.main]
                      : null
                  }
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, "main")
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => {
                    return new Promise((resolve, reject) => {
                      // 업로드한 파일이 이미지 형식인지 확인
                      const isImg =
                        file.type === "image/jpeg" ||
                        file.type === "image/jpg" ||
                        file.type === "image/png" ||
                        file.type === "image/gif";
                      if (!isImg) {
                        alert(
                          "이미지 파일(jpeg, jpg, png, gif)만 업로드 되어야 합니다.",
                        );
                        return Upload.LIST_IGNORE;
                      }
                      // 이미지 사이즈를 확인하기 위해 업로드한 파일을 읽고 이미지로 변환
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.addEventListener("load", (event) => {
                        const loadedImgUrl = event.target.result;
                        const image = document.createElement("img");
                        image.src = loadedImgUrl;
                        image.addEventListener("load", () => {
                          const { width, height } = image;
                          if (width !== 1000 && height !== 1000) {
                            alert(
                              "이미지의 크기는 1000px x 1000px 이어야 합니다.",
                            );
                            return Upload.LIST_IGNORE;
                          } else {
                            return resolve(false);
                          }
                        });
                      });
                    });
                  }}
                >
                  {Object.keys(productImg.main)?.length !== 0 ? null : (
                    <div className="product-register-upload-img-icon-wrap">
                      <img
                        className="product-register-upload-img-icon"
                        src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                      />
                    </div>
                  )}
                </Upload>
              ) : (
                <Upload
                  className="product-register-upload-img-wrap"
                  // action="/upload.do"
                  listType="picture-card"
                  maxCount={1}
                  // fileList={[productImg.main]}
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, "main")
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => {
                    return new Promise((resolve, reject) => {
                      // 업로드한 파일이 이미지 형식인지 확인
                      const isImg =
                        file.type === "image/jpeg" ||
                        file.type === "image/jpg" ||
                        file.type === "image/png" ||
                        file.type === "image/gif";
                      if (!isImg) {
                        alert(
                          "이미지 파일(jpeg, jpg, png, gif)만 업로드 되어야 합니다.",
                        );
                        return Upload.LIST_IGNORE;
                      }
                      // 이미지 사이즈를 확인하기 위해 업로드한 파일을 읽고 이미지로 변환
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.addEventListener("load", (event) => {
                        const loadedImgUrl = event.target.result;
                        const image = document.createElement("img");
                        image.src = loadedImgUrl;
                        image.addEventListener("load", () => {
                          const { width, height } = image;
                          if (width !== 1000 && height !== 1000) {
                            alert(
                              "이미지의 크기는 1000px x 1000px 이어야 합니다.",
                            );
                            return Upload.LIST_IGNORE;
                          } else {
                            return resolve(false);
                          }
                        });
                      });
                    });
                  }}
                >
                  <div className="product-register-upload-img-icon-wrap">
                    <img
                      className="product-register-upload-img-icon"
                      src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                    />
                  </div>
                </Upload>
              )}
              <span
                className="product-register-upload-img-help"
                style={{ color: "#fe2b4b" }}
              >
                * 필수크기 : 1000 x 1000px{"\n"}* 여백: 양쪽 각각 100px (총
                200px){"\n"}
                <span style={{ marginLeft: "40px" }}>
                  제품 모양에 따라 상하/좌우 중 택1
                </span>
                {"\n"}* 상하 여백 맞출 시, 좌우 가운데 정렬{"\n"}* 좌우 여백
                맞출 시, 상하 가운데 정렬
              </span>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-upload-img"
              label="추가이미지"
              labelAlign="left"
              multiple
              colon={false}
              labelCol={{ span: 2 }}
              wrapperCol={{ span: 22 }}
            >
              {match.params.hasOwnProperty("id") ? (
                <Upload.Dragger
                  className="product-register-upload-img-wrap drag-area"
                  // action="/upload.do"
                  listType="picture-card"
                  multiple
                  // maxCount={9}
                  fileList={productImg.remainder}
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, "additional")
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => false}
                  showUploadList={{ showRemoveIcon: false }}
                  disabled={productImg.remainder?.length !== 0}
                >
                  <div className="product-register-upload-img-icon-wrap">
                    {productImg.remainder?.length !== 0 ? (
                      <Button
                        type="danger"
                        onClick={() => {
                          if (
                            !productImg.remainder[0].hasOwnProperty(
                              "originFileObj",
                            )
                          ) {
                            setDeletedImgCount({
                              ...deletedImgCount,
                              remainder: productImg.remainder?.length,
                            });
                          }
                          setProductImg({ ...productImg, remainder: [] });
                        }}
                      >
                        전체 삭제
                      </Button>
                    ) : (
                      <img
                        className="product-register-upload-img-icon"
                        src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                      />
                    )}
                    <div>
                      {productImg.remainder?.length !== 0
                        ? "이미지 전체 삭제 후, 다시 재등록해주시길 바랍니다."
                        : "업로드할 이미지를 한번에 드래그하여 끌어다 놓으세요"}
                    </div>
                  </div>
                </Upload.Dragger>
              ) : (
                <Upload
                  className="product-register-upload-img-wrap"
                  // action="/upload.do"
                  listType="picture-card"
                  maxCount={9}
                  // fileList={productImg.remainder}
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, "additional")
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => false}
                >
                  <div className="product-register-upload-img-icon-wrap">
                    <img
                      className="product-register-upload-img-icon"
                      src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                    />
                  </div>
                </Upload>
              )}
              <span className="product-register-upload-img-help">
                권장크기 : 1000 x 1000px{`\n`}추가이미지는 최대 9장
              </span>
            </Form.Item>
          </div>
        </>

        {/*상품설명*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">상품설명</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "25px 25px 10px",
              height: "fit-content",
            }}
          >
            <Form.Item>
              {match.params.hasOwnProperty("id") ? (
                <Upload.Dragger
                  className="product-register-upload-img-wrap drag-area"
                  // action="/upload.do"
                  multiple
                  fileList={productDescriptionImg}
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, "description")
                  }
                  onPreview={handlePreview}
                  beforeUpload={(file) => false}
                  showUploadList={false}
                  disabled={productDescriptionImg?.length !== 0}
                >
                  <div className="product-register-upload-img-icon-wrap">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {productDescriptionImg?.length !== 0 ? (
                        // <Button
                        // 	type="danger"
                        // 	onClick={() => {
                        // 		if (
                        // 			!productDescriptionImg[0].hasOwnProperty(
                        // 				"originFileObj"
                        // 			)
                        // 		) {
                        // 			setDeletedImgCount({
                        // 				...deletedImgCount,
                        // 				description: productDescriptionImg?.length,
                        // 			});
                        // 		}
                        // 		setProductDescriptionImg([]);
                        // 	}}
                        // >
                        // 	전체 삭제
                        // </Button>
                        <>
                          <img
                            className="product-register-upload-detail-img-icon"
                            src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/answer_icon_active.png`}
                          />
                          <div className="product-register-upload-detail-done">
                            작성된 내용이 있습니다.
                          </div>
                          <Button
                            className="product-register-upload-detail-modal-open"
                            style={{
                              cursor: "pointer",
                              padding: "auto 2rem",
                            }}
                            onClick={handleExplainProductModalOpen}
                          >
                            수정 >
                          </Button>
                        </>
                      ) : (
                        <img
                          className="product-register-upload-img-icon"
                          src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                        />
                      )}
                      <div>
                        {productDescriptionImg?.length !== 0
                          ? ""
                          : "이미지를 드래그하여 끌어다 놓으세요"}
                      </div>
                    </div>
                  </div>
                </Upload.Dragger>
              ) : (
                <Upload.Dragger
                  className="product-register-upload-img-wrap drag-area"
                  // action="/upload.do"
                  multiple
                  onChange={({ file, fileList, event }) =>
                    handleImageChange(file, fileList, event, "description")
                  }
                  onPreview={handlePreview}
                  showUploadList={false}
                  disabled={productDescriptionImg?.length !== 0}
                  beforeUpload={(file) => false}
                >
                  <div className="product-register-upload-img-icon-wrap">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flexDirection: "column",
                        alignItems: "center",
                      }}
                    >
                      {productDescriptionImg?.length !== 0 ? (
                        <>
                          <img
                            className="product-register-upload-detail-img-icon"
                            src={`${process.env.REACT_APP_HOST}/assets/images/inquiry/answer_icon_active.png`}
                          />
                          <div className="product-register-upload-detail-done">
                            작성된 내용이 있습니다.
                          </div>
                          <Button
                            className="product-register-upload-detail-modal-open"
                            style={{
                              cursor: "pointer",
                              padding: "auto 2rem",
                            }}
                            onClick={handleExplainProductModalOpen}
                          >
                            수정 >
                          </Button>
                        </>
                      ) : (
                        <img
                          className="product-register-upload-img-icon"
                          src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon-1.png`}
                        />
                      )}
                      <div>
                        {productDescriptionImg?.length !== 0
                          ? ""
                          : "이미지를 드래그하여 끌어다 놓으세요"}
                      </div>
                    </div>
                  </div>
                </Upload.Dragger>
              )}
            </Form.Item>
          </div>
        </>

        {/*상품 속성*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">상품 속성</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="center-label"
              label="상품군"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
              required
            >
              <Row align="middle" wrap={false}>
                <Col span={8}>
                  <Select
                    placeholder="선택"
                    value={product.product_type}
                    onChange={handleSelectChange}
                  >
                    {productTypeItems.map((item, idx) => (
                      <Option
                        key={`${item.id}_${idx}`}
                        id="product_type"
                        value={item.value}
                      >
                        {item.label}
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Checkbox
                  name="ref_product_detail"
                  value="상품 상세 참조"
                  checked={options.ref_product_detail}
                  onChange={handleChange}
                  disabled={
                    options.product_type === "" || options.product_type === 6
                  }
                  style={{ marginLeft: 15 }}
                >
                  상품 상세 참조
                </Checkbox>
              </Row>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />

            {/*의료기기*/}
            {options.product_type === 0 && (
              <>
                <Form.Item
                  className="center-label"
                  label="품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_detail_name"
                    value={productDetail.product_detail_name}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="모델명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_model_name"
                    value={productDetail.product_model_name}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  label="의료기기법상 허가 신고번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className="product-register-radio-group-wrap"
                    name="approval_number"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.approval_number}
                  />
                  <Input
                    name="approval_number"
                    value={productDetail.approval_number}
                    onChange={handleProductDetailChange}
                    disabled={!options.approval_number}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="광고사전심의필 유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="ad_pre_deliberation"
                    value={productDetail.ad_pre_deliberation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  label="정격전압"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className="product-register-radio-group-wrap"
                    name="medical_rated_voltage"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.medical_rated_voltage}
                  />
                  <Input
                    name="medical_rated_voltage"
                    value={productDetail.medical_rated_voltage}
                    onChange={handleProductDetailChange}
                    disabled={!options.medical_rated_voltage}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  label="소비전력"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className="product-register-radio-group-wrap"
                    name="medical_power_consumption"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.medical_power_consumption}
                  />
                  <Input
                    name="medical_power_consumption"
                    value={productDetail.medical_power_consumption}
                    onChange={handleProductDetailChange}
                    disabled={!options.medical_power_consumption}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="동일 모델의 출시연월"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="release_date_same_model"
                    value={productDetail.release_date_same_model}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조자(사)"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="product_detail_maker"
                    value={productDetail.product_detail_maker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="사용목적"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="purpose"
                    value={productDetail.purpose}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="사용방법"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="instruction"
                    value={productDetail.instruction}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="취급시 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="품질보증기준"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="quality_assurance_standards"
                    value={productDetail.quality_assurance_standards}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}

            {/*화장품*/}
            {options.product_type === 1 && (
              <>
                <Form.Item
                  className="center-label"
                  label="용량 및 중량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity"
                    value={productDetail.capacity}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="제품 주요사양"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="product_specification"
                    value={productDetail.product_specification}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="사용기한 또는 개봉 후 사용기간"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="validation_date"
                    value={productDetail.validation_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="사용방법"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="instruction"
                    value={productDetail.instruction}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="화장품제조업자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="product_detail_maker"
                    value={productDetail.product_detail_maker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조국"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="maker_country"
                    value={productDetail.maker_country}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="화장품책임판매업자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="화장품법에 따라 기재 표시하여야 하는 모든성분"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="product_substance_information"
                    value={productDetail.product_substance_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="기능성 화장품의 경우 화장품법에 따른 식품의약품안전처 심사필 유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="food_drag_ministry"
                    value={productDetail.food_drag_ministry}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="사용할 때 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="품질보증기준"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="quality_assurance_standards"
                    value={productDetail.quality_assurance_standards}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}

            {/*가공식품*/}
            {options.product_type === 2 && (
              <>
                <Form.Item
                  className="center-label"
                  label="제품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_detail_name"
                    value={productDetail.product_detail_name}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="식품의 유형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="food_type"
                    value={productDetail.food_type}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="생산자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="소재지"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="location"
                    value={productDetail.location}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조연월일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="make_date"
                    value={productDetail.make_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="유통기한 또는 품질유지기한"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="validation_date"
                    value={productDetail.validation_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="포장단위별 내용물의 용량(중량), 수량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity_packaging"
                    value={productDetail.capacity_packaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="포장단위별 수량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="quantity_packaging"
                    value={productDetail.quantity_packaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="원재료명 및 함량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="product_substance_information"
                    value={productDetail.product_substance_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  label="영양성분"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className="product-register-radio-group-wrap"
                    name="product_nutrient"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.product_nutrient}
                  />
                  <Input
                    name="product_nutrient"
                    value={productDetail.product_nutrient}
                    onChange={handleProductDetailChange}
                    disabled={!options.product_nutrient}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap center-label"
                  label="유전자변형식품에 해당하는 경우의 표시"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="is_genetic_modification"
                    checked={productDetail.is_genetic_modification}
                    value={true}
                    onChange={handleChange}
                  >
                    유전자변형식품
                  </Checkbox>
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="소비자안전을 위한 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap center-label"
                  label="수입식품에 해당하는 경우"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="is_imported"
                    checked={productDetail.is_imported}
                    value={true}
                    onChange={handleChange}
                  >
                    수입식품안전관리특별법에 따른 수입신고를 필함
                  </Checkbox>
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}

            {/*건강기능식품*/}
            {options.product_type === 3 && (
              <>
                <Form.Item
                  className="center-label"
                  label="제품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_detail_name"
                    value={productDetail.product_detail_name}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="식품의 유형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="food_type"
                    value={productDetail.food_type}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조업소"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_detail_maker"
                    value={productDetail.product_detail_maker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="소재지"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="location"
                    value={productDetail.location}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조연월일"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="make_date"
                    value={productDetail.make_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="유통기한"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="validation_date"
                    value={productDetail.validation_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="포장단위별 내용물의 용량(중량), 수량"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity_packaging"
                    value={productDetail.capacity_packaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="포장단위별 수량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="quantity_packaging"
                    value={productDetail.quantity_packaging}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="원재료명 및 함량"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="product_substance_information"
                    value={productDetail.product_substance_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="영양정보"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="product_nutrient"
                    value={productDetail.product_nutrient}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="기능정보"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="product_specification"
                    value={productDetail.product_specification}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="섭취량, 섭취방법 및 섭취 시 주의사항"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution_intake"
                    value={productDetail.caution_intake}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="질병의 예방 및 치료를 위한 의약품이 아니라는 내용의 문구"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="not_drug_information"
                    value={productDetail.not_drug_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap center-label"
                  label="유전자변형식품에 해당되는 경우의 표시"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="is_genetic_modification"
                    checked={productDetail.is_genetic_modification}
                    value={true}
                    onChange={handleChange}
                  >
                    유전자변형식품
                  </Checkbox>
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap center-label"
                  label="수입식품에 해당되는 경우"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Checkbox
                    name="is_imported"
                    checked={productDetail.is_imported}
                    value={true}
                    onChange={handleChange}
                  >
                    수입식품안전관리특별법에 따른 수입신고를 필함
                  </Checkbox>
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="소비자안전을 위한 주의사항"
                  labelAlign="left"
                  labelWrap
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}

            {/*생활화학제품*/}
            {options.product_type === 4 && (
              <>
                <Form.Item
                  className="center-label"
                  label="품목 및 제품명"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_detail_name"
                    value={productDetail.product_detail_name}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="용도 및 제형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="usage_formulation"
                    value={productDetail.usage_formulation}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조연월"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="make_date"
                    value={productDetail.make_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="유통기한"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="validation_date"
                    value={productDetail.validation_date}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="중량•용량•매수"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity"
                    value={productDetail.capacity}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="효과•효능"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="effectiveness"
                    value={productDetail.effectiveness}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  label="수입자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className="product-register-radio-group-wrap"
                    name="importer"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.importer}
                  />
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                    disabled={!options.importer}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조국"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="maker_country"
                    value={productDetail.maker_country}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조자(사)"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="product_detail_maker"
                    value={productDetail.product_detail_maker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="어린이 보호포장 대상 제품유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="child_protective_packaging_product"
                    value={productDetail.child_protective_packaging_product}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제품에 사용된 화학 물질 명칭"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_substance_information"
                    value={productDetail.product_substance_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="사용상 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="안전기준 적합확인 신고번호(자가검사번호) 또는 안전확인대상 생활화학제품 승인번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="approval_number"
                    value={productDetail.approval_number}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}

            {/*살생물제품*/}
            {options.product_type === 5 && (
              <>
                <Form.Item
                  className="center-label"
                  label="제품명 및 제품유형"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_detail_name"
                    value={productDetail.product_detail_name}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="중량 또는 용량 및 표준사용량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="capacity"
                    value={productDetail.capacity}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="효과•효능"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="effectiveness"
                    value={productDetail.effectiveness}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="사용대상자 및 사용범위"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="usage_information"
                    value={productDetail.usage_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  label="수입자"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Radio.Group
                    className="product-register-radio-group-wrap"
                    name="importer"
                    options={inputOptions}
                    onChange={handleChange}
                    value={options.importer}
                  />
                  <Input
                    name="importer"
                    value={productDetail.importer}
                    onChange={handleProductDetailChange}
                    disabled={!options.importer}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조국"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="maker_country"
                    value={productDetail.maker_country}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제조자(사)"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 6 }}
                >
                  <Input
                    name="product_detail_maker"
                    value={productDetail.product_detail_maker}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="어린이 보호포장 대상 제품유무"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="child_protective_packaging_product"
                    value={productDetail.child_protective_packaging_product}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="살생물물질, 나노물질, 유해화학물질(또는 중점관리물질)의 명칭"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_substance_information"
                    value={productDetail.product_substance_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="제품 유해성•위해성 표시"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="product_hazard_information"
                    value={productDetail.product_hazard_information}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="product-register-form-input-wrap"
                  label="사용방법 및 사용상 주의사항"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input.TextArea
                    name="caution"
                    value={productDetail.caution}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
                <Form.Item
                  className="center-label"
                  label="승인번호"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 3 }}
                  wrapperCol={{ span: 21 }}
                >
                  <Input
                    name="approval_number"
                    value={productDetail.approval_number}
                    onChange={handleProductDetailChange}
                  />
                </Form.Item>
                <Divider className="product-register-form-input-divider" />
              </>
            )}

            <Form.Item
              className="center-label"
              label="소비자 상담 관련 전화번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input
                name="cs_number"
                value={product.cs_number}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="제품하자·오배송 등에 따른 청약철회 등의 경우 청약철회 등을 할 수 있는 기간 및 통신판매업자가 부담하는 반품비용 등에 관한 정보"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="cancellation_information"
                value={options.cancellation_information}
                onChange={handleChange}
              >
                <Space
                  className="product-register-select-group-wrap"
                  direction="vertical"
                >
                  <Radio value={1}>
                    전자상거래등에서의소비자보호에관한법률 등에 의한 제품의 하자
                    또는 오배송 등으로 인한 청약철회의 경우에는 상품 수령 후
                    3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터 30일
                    이내에 청약철회를 할 수 있으며, 반품 비용은 통신판매업자가
                    부담합니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.cancellation_information === 3 ? (
                    <Input
                      name="cancellation_information"
                      value={product.cancellation_information}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="제품하자가 아닌 소비자의 단순변심, 착오구매에 따른 청약철회등이 불가능한 경우 그 구체적 사유와 근거"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="cancellation_impossible_information"
                value={options.cancellation_impossible_information}
                onChange={handleChange}
              >
                <Space
                  className="product-register-select-group-wrap"
                  direction="vertical"
                >
                  <Radio value={1}>
                    전자상거래 등에서의 소비자보호에 관한 법률 등에 의한
                    청약철회 제한 사유에 해당하는 경우 및 기타 객관적으로 이에
                    준하는 것으로 인정되는 경우 청약철회가 제한될 수 있습니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.cancellation_impossible_information === 3 ? (
                    <Input
                      name="cancellation_impossible_information"
                      value={product.cancellation_impossible_information}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="재화등의 교환·반품·보증 조건 및 품질보증기준"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="quality_assurance_standards_information"
                value={options.quality_assurance_standards_information}
                onChange={handleChange}
              >
                <Space
                  className="product-register-select-group-wrap"
                  direction="vertical"
                >
                  <Radio value={1}>
                    소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에
                    따릅니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.quality_assurance_standards_information === 3 ? (
                    <Input
                      name="quality_assurance_standards_information"
                      value={product.quality_assurance_standards_information}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="대금을 환불받기 위한 방법과 환불이 지연될 경우 지연에 따른 배상금을 지급받을 수 있다는 사실 및 배상금 지급의 구체적 조건 및 절차"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="refund_indemnity_informaion"
                value={options.refund_indemnity_informaion}
                onChange={handleChange}
              >
                <Space
                  className="product-register-select-group-wrap"
                  direction="vertical"
                >
                  <Radio value={1}>
                    주문취소 및 대금의 환불은 당신의 영양제 마이페이지에서
                    신청할 수 있으며, 전자상거래 등에서의 소비자보호에 관한
                    법률에 따라 소비자의 청약철회 후 판매자가 재화 등을 반환
                    받은 날로부터 3영업일 이내에 지급받은 대금의 환급을 정당한
                    사유 없이 지연하는 때에는 소비자는 지연기간에 대해서 연
                    15%의 지연배상금을 판매자에게 청구할 수 있습니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.refund_indemnity_informaion === 3 ? (
                    <Input
                      name="refund_indemnity_informaion"
                      value={product.refund_indemnity_informaion}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              label="소비자피해보상의 처리, 재화등에 대한 불만 처리 및 소비자와 사업자 사이의 분쟁처리에 관한 사항"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Radio.Group
                name="dispute_information"
                value={options.dispute_information}
                onChange={handleChange}
              >
                <Space
                  className="product-register-select-group-wrap"
                  direction="vertical"
                >
                  <Radio value={1}>
                    소비자분쟁해결기준(공정거래위원회 고시) 및 관계법령에
                    따릅니다.
                  </Radio>
                  <Radio value={2}>상품상세 참조</Radio>
                  <Radio value={3}>직접입력</Radio>
                  {options.dispute_information === 3 ? (
                    <Input
                      name="dispute_information"
                      value={product.dispute_information}
                      onChange={handleChange}
                    />
                  ) : null}
                </Space>
              </Radio.Group>
            </Form.Item>
          </div>
        </>

        {/*상품 속성-영양제*/}
        {Object.keys(categoryOption.category3)?.length !== 0 &&
        isNutritionalPro() &&
        product.product_category_name?.length !== 0 ? (
          <>
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className="product-register-box-title">상품 속성</span>
              <span className="product-register-box-subtitle">
                {product.product_category_name}
              </span>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                borderTop: 0,
                padding: "15px 20px 45px",
                height: "fit-content",
              }}
            >
              <Form.Item
                className="product-register-nutrients-header-wrap"
                label="건강식품 인증 필수"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 22 }}
              ></Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap add-padding"
                label="영양소 원료명 (식약처고시)"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <p className="product-register-nutrients-subtitle">비타민</p>
                <Row style={{ rowGap: 8, marginBottom: 20 }}>
                  {nutrientCategoryList.vitamin?.length !== 0 &&
                    nutrientCategoryList.vitamin.map((vitamin) => (
                      <Col span={4}>
                        <Checkbox
                          key={vitamin.id}
                          id={vitamin.nutrient_id}
                          name="vitamin"
                          value={0}
                          onChange={handleChange}
                          checked={selectNutrients.some(
                            (selectNutrient) =>
                              JSON.stringify(selectNutrient) ===
                              JSON.stringify(vitamin),
                          )}
                        >
                          {vitamin.nutrient_name}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
                <p className="product-register-nutrients-subtitle">미네랄</p>
                <Row style={{ rowGap: 8, marginBottom: 20 }}>
                  {nutrientCategoryList.mineral?.length !== 0 &&
                    nutrientCategoryList.mineral.map((mineral) => (
                      <Col span={4}>
                        <Checkbox
                          key={mineral.id}
                          id={mineral.nutrient_id}
                          name="mineral"
                          value={0}
                          onChange={handleChange}
                          checked={selectNutrients.some(
                            (selectNutrient) =>
                              JSON.stringify(selectNutrient) ===
                              JSON.stringify(mineral),
                          )}
                        >
                          {mineral.nutrient_name}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
                <p className="product-register-nutrients-subtitle">뉴트리션</p>
                <Row style={{ rowGap: 8, marginBottom: 20 }}>
                  {nutrientCategoryList.nutrition?.length !== 0 &&
                    nutrientCategoryList.nutrition.map((nutrition) => (
                      <Col span={4}>
                        <Checkbox
                          key={nutrition.id}
                          id={nutrition.nutrient_id}
                          name="nutrition"
                          value={0}
                          onChange={handleChange}
                          checked={selectNutrients.some(
                            (selectNutrient) =>
                              JSON.stringify(selectNutrient) ===
                              JSON.stringify(nutrition),
                          )}
                        >
                          {nutrition.nutrient_name === "플라보놀배당체" ||
                          nutrition.nutrient_name === "로르산"
                            ? nutrition.nutrient_category_name
                            : nutrition.nutrient_name}
                        </Checkbox>
                      </Col>
                    ))}
                </Row>
                {selectNutrients?.length !== 0 &&
                  selectNutrients.map((nutrient) => (
                    <>
                      <Divider className="product-register-form-input-divider" />
                      <Row
                        key={`nutrient_content_${nutrient.id}`}
                        className="add-nutrients-wrap"
                      >
                        <img
                          className="delete-nutrients-icon-wrap"
                          src={`${process.env.REACT_APP_HOST}/assets/images/product/Icon.png`}
                          onClick={() => deleteNutritionInfo(nutrient)}
                        />
                        <Col span={5}>
                          <span className="product-register-nutrients-subtitle">
                            {nutrient.nutrient_name}
                          </span>
                        </Col>
                        <Input
                          type="number"
                          className="add-nutrients-input-wrap"
                          name={nutrient.nutrient_id}
                          value={nutrientInfo[nutrient.nutrient_id]}
                          min={0}
                          onChange={handleNutrientInfoChange}
                          addonAfter={<span>{nutrient.nutrient_unit}</span>}
                        />
                      </Row>
                    </>
                  ))}
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap add-padding"
                label="알레르기 영양정보"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Row style={{ rowGap: 8 }}>
                  {allergyItems.map((allergy, idx) => (
                    <Col span={4}>
                      <Checkbox
                        key={`allergy_${idx}`}
                        id={allergy.value}
                        name="nutrient_allergy"
                        value={1}
                        onChange={handleChange}
                        checked={nutrientsAllergy[allergy.value] === 1}
                      >
                        {allergy.label}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap add-padding"
                label="효능"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Row style={{ rowGap: 8 }}>
                  {nutrientSearchOption.effect.map((effect, idx) => (
                    <Col span={4}>
                      <Checkbox
                        key={`effect_${idx}`}
                        id={effect.effect_id}
                        name="nutrient_effect"
                        value={effect.effect_id}
                        onChange={handleChange}
                        checked={product.nutrient_effect.includes(
                          effect.effect_id,
                        )}
                      >
                        {effect.effect_name}
                      </Checkbox>
                    </Col>
                  ))}
                </Row>
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-header-wrap"
                label="기타속성"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 22 }}
                style={{ borderTop: 0 }}
              ></Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap add-padding"
                label="제품타입"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Radio.Group
                  name="formulation"
                  onChange={handleChange}
                  value={product.formulation}
                  style={{ width: "100%" }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {formulationItems.map((formulationItem, idx) => (
                      <Col span={4}>
                        <Radio
                          key={`formulation_${idx}`}
                          value={formulationItem.value}
                        >
                          {formulationItem.label}
                        </Radio>
                      </Col>
                    ))}
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap center-label"
                label="성별"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Radio.Group
                  name="gender"
                  onChange={handleChange}
                  value={options.gender}
                  style={{ width: "100%" }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {genderItems.map((gender, idx) => (
                      <Col span={4}>
                        <Radio key={`gender_${idx}`} value={gender.value}>
                          {gender.label}
                        </Radio>
                      </Col>
                    ))}
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap add-padding"
                label="섭취대상"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Radio.Group
                  name="target_age"
                  onChange={handleChange}
                  value={options.target_age}
                  style={{ width: "100%" }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {targetAgeItems.map((age, idx) => (
                      <Col span={4}>
                        <Radio key={`age_${idx}`} value={age.value}>
                          {age.label}
                        </Radio>
                      </Col>
                    ))}
                  </Row>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap center-label"
                label="특징"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Row>
                  <Col span={4}>
                    <Checkbox
                      name="pregnant"
                      value={true}
                      onChange={handleChange}
                      checked={options.pregnant}
                    >
                      임산부
                    </Checkbox>
                  </Col>
                  <Col span={4}>
                    <Checkbox
                      name="began"
                      value={1}
                      onChange={handleChange}
                      checked={productKpi.began}
                    >
                      비건
                    </Checkbox>
                  </Col>
                </Row>
              </Form.Item>
              {nutrientSearchOption.standard_content?.length > 0 ? (
                <Form.Item
                  className="product-register-nutrients-item-wrap center-label"
                  label="함량"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 2 }}
                  wrapperCol={{ span: 22 }}
                >
                  <Radio.Group
                    name="nutrient_standard"
                    onChange={handleChange}
                    value={product.nutrient_standard}
                    style={{ width: "100%" }}
                  >
                    <Row style={{ rowGap: 8 }}>
                      {nutrientSearchOption.standard_content.map(
                        (nutrient_standard, idx) => {
                          let standardContentUnit = "";
                          if (nutrient_standard.under_yn) {
                            standardContentUnit = "미만";
                          } else if (nutrient_standard.over_yn) {
                            standardContentUnit = "미만";
                          } else if (nutrient_standard.less_yn) {
                            standardContentUnit = "이하";
                          } else if (nutrient_standard.more_than_yn) {
                            standardContentUnit = "이상";
                          }
                          return (
                            <Col span={4}>
                              <Radio
                                key={`nutrient_standard_${idx}`}
                                value={nutrient_standard.id}
                              >{`${nutrient_standard.content}${nutrient_standard.nutrient_unit} ${standardContentUnit}`}</Radio>
                            </Col>
                          );
                        },
                      )}
                    </Row>
                  </Radio.Group>
                </Form.Item>
              ) : null}
              {nutrientSearchOption.additional_ingredient?.length > 0 ? (
                <Form.Item
                  className="product-register-nutrients-item-wrap center-label"
                  label="추가성분"
                  labelAlign="left"
                  colon={false}
                  labelCol={{ span: 2 }}
                  wrapperCol={{ span: 22 }}
                >
                  <Row style={{ rowGap: 8 }}>
                    {nutrientSearchOption.additional_ingredient.map(
                      (ingredient, idx) => (
                        <Col span={4}>
                          <Checkbox
                            key={`ingredient_${idx}`}
                            id={ingredient.ingredient_id}
                            name="nutrient_additional_ingredient"
                            value={ingredient.ingredient_id}
                            onChange={handleChange}
                            checked={product.nutrient_additional_ingredient.includes(
                              ingredient.ingredient_id,
                            )}
                          >
                            {ingredient.ingredient_name}
                          </Checkbox>
                        </Col>
                      ),
                    )}
                  </Row>
                </Form.Item>
              ) : null}
              <Form.Item
                className="product-register-form-input-wrap product-register-nutrients-item-wrap center-label"
                label="섭취횟수"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Col span={4} style={{ marginRight: 20 }}>
                  <Input
                    type="number"
                    name="intakes_per_day"
                    value={nutrients.intakes_per_day}
                    min={0}
                    onChange={handleNutrientsChange}
                    addonAfter={<span className="product-price-label">회</span>}
                  />
                </Col>
                <Col span={6}>
                  <Input
                    type="number"
                    name="num_per_one"
                    value={nutrients.num_per_one}
                    min={0}
                    onChange={handleNutrientsChange}
                    addonAfter={
                      <Select
                        className="product-price-label"
                        placeholder="선택"
                        value={product.for_person_unit}
                        onChange={handleSelectChange}
                        style={{ width: 90 }}
                      >
                        {forPersonUnitItems.map((unit, idx) => (
                          <Option
                            key={`unit_${idx}`}
                            id="for_person_unit"
                            value={unit.value}
                          >
                            {unit.label}
                          </Option>
                        ))}
                      </Select>
                    }
                  />
                </Col>
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap center-label"
                label="1일 총 섭취량"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 6 }}
              >
                <Input
                  type="number"
                  name="for_person"
                  value={nutrients.for_person}
                  min={0}
                  onChange={handleNutrientsChange}
                />
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap center-label"
                label="복용시간대"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 22 }}
              >
                <Input
                  name="take_medicine_time"
                  value={nutrients.take_medicine_time}
                  onChange={handleNutrientsChange}
                />
              </Form.Item>
              <Form.Item
                className="product-register-nutrients-item-wrap center-label"
                label="판매단위"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 2 }}
                wrapperCol={{ span: 6 }}
              >
                <Input
                  type="number"
                  name="unit"
                  value={productKpi.unit}
                  min={0}
                  onChange={handleProductKpiChange}
                />
              </Form.Item>
              {product.hasOwnProperty("product_category_id") &&
                product.product_category_id !== "vitamin_multi" &&
                product.product_category_id !== "vitamin_b" && (
                  <Form.Item
                    className="product-register-nutrients-item-wrap center-label"
                    label="대표영양소 함량"
                    labelAlign="left"
                    colon={false}
                    labelCol={{ span: 2 }}
                    wrapperCol={{ span: 6 }}
                  >
                    <Input
                      name="top_nutrient_content"
                      value={product.top_nutrient_content}
                      onChange={handleChange}
                      addonAfter={<span>{product.top_nutrient_unit}</span>}
                    />
                  </Form.Item>
                )}
            </div>
          </>
        ) : null}

        {/*배송*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">배송</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="center-label"
              label="택배사"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 6 }}
            >
              <Select
                placeholder="선택"
                value={product.delivery_company}
                onChange={handleSelectChange}
              >
                {courierCompanyItems.map((courierCompany, idx) => (
                  <Option
                    key={`courierCompany_${idx}`}
                    id="delivery_company"
                    value={courierCompany.value}
                  >
                    {courierCompany.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            {/*<Form.Item*/}
            {/*    className="product-register-form-input-wrap center-label"*/}
            {/*    label="배송기간"*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{span: 3}}*/}
            {/*    wrapperCol={{span: 6}}*/}
            {/*>*/}
            {/*    <Select placeholder="선택" defaultValue={1} value={product.delivery_due}*/}
            {/*            onChange={handleSelectChange}>*/}
            {/*        {deliveryDueItems.map((item, idx) => <Option key={`delivery_due_${idx}`}*/}
            {/*                                                     id="delivery_due"*/}
            {/*                                                     value={item.value}>{item.label}</Option>)}*/}
            {/*    </Select>*/}
            {/*</Form.Item>*/}
            {/*<Divider className="product-register-form-input-divider"/>*/}
            {/*<Form.Item*/}
            {/*    className="product-register-form-input-wrap center-label"*/}
            {/*    label="배송비"*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{span: 3}}*/}
            {/*    wrapperCol={{span: 9}}*/}
            {/*>*/}
            {/*    <Select className="product-register-delivery-type-select" placeholder="선택"*/}
            {/*            defaultValue={"당일 배송"} value={product.delivery_type} onChange={handleSelectChange}>*/}
            {/*        {deliveryTypeItems.map((item, idx) => <Option key={`delivery_type_${idx}`}*/}
            {/*                                                      id="delivery_type"*/}
            {/*                                                      value={item.value}>{item.label}</Option>)}*/}
            {/*    </Select>*/}
            {/*    <Input*/}
            {/*        type="number"*/}
            {/*        name="delivery_price"*/}
            {/*        value={product.delivery_price}*/}
            {/*        min={0}*/}
            {/*        onChange={handleChange}*/}
            {/*        addonAfter={<span className="product-price-label">원</span>}*/}
            {/*        disabled={product.delivery_type === "당영한 무료배송"}*/}
            {/*    />*/}
            {/*</Form.Item>*/}
            {/*<Divider className="product-register-form-input-divider"/>*/}
            {/*<Form.Item*/}
            {/*    className="center-label"*/}
            {/*    label="지역별 차등 배송비"*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{span: 3}}*/}
            {/*    wrapperCol={{span: 21}}*/}
            {/*>*/}
            {/*    <Input name="delivery_price_region" value={product.delivery_price_region}*/}
            {/*           onChange={handleChange}/>*/}
            {/*</Form.Item>*/}
            {/*<Divider className="product-register-form-input-divider"/>*/}
            <Form.Item
              className="center-label"
              label="출고지"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input
                name="shipment_place"
                value={product.shipment_place}
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </>

        {/*반품배송*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">반품배송</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="center-label"
              label="반품/교환 택배사"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 6 }}
            >
              <Select
                placeholder="선택"
                value={product.delivery_company_return_exchange}
                onChange={handleSelectChange}
              >
                {courierCompanyItems.map((courierCompany, idx) => (
                  <Option
                    key={`courierCompany_${idx}`}
                    id="delivery_company_return_exchange"
                    value={courierCompany.value}
                  >
                    {courierCompany.label}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-form-input-wrap center-label"
              label="반품배송비(편도)"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 3 }}
            >
              <Input
                type="number"
                name="delivery_price_return"
                value={product.delivery_price_return}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">원</span>}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-form-input-wrap center-label"
              label="교환배송비(왕복)"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 3 }}
            >
              <Input
                type="number"
                name="delivery_price_exchange"
                value={product.delivery_price_exchange}
                min={0}
                onChange={handleChange}
                addonAfter={<span className="product-price-label">원</span>}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="center-label"
              label="반품/교환지"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input
                name="shipment_place_return_exchange"
                value={product.shipment_place_return_exchange}
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </>

        {/*A/S 특이사항*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">A/S 특이사항</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="center-label"
              label="A/S 전화번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input
                name="as_phone"
                value={product.as_phone}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-form-input-wrap"
              label="A/S 안내"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input.TextArea
                name="as_information"
                value={product.as_information}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="product-register-form-input-wrap"
              label="판매자 특이사항"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input.TextArea
                name="seller_specifics"
                value={product.seller_specifics}
                onChange={handleChange}
              />
            </Form.Item>
          </div>
        </>

        {/*연관상품 관리*/}
        {user.role === "super_admin" && (
          <>
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className="product-register-box-title">연관상품 관리</span>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                borderTop: 0,
                padding: "20px 25px 50px",
                height: "fit-content",
              }}
            >
              <Form.Item
                className="product-register-form-input-wrap"
                label="등록된 상품"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                <Row>
                  {relatedProductList.map((product, idx) => (
                    <div
                      key={`related_product_${idx}`}
                      className="related-product-wrap"
                    >
                      <div className="related-product-index-wrap">
                        {idx + 1}
                      </div>
                      <div className="related-product-image-wrap product-image">
                        <img
                          className="related-product-image"
                          // onError={({ currentTarget }) => {
                          //     currentTarget.onerror = null; // prevents looping
                          //     currentTarget.src = `${process.env.REACT_APP_HOST}/assets/images/icons/recommend/recommend-nutrients-noti.png`;
                          // }}
                          src={`${process.env.REACT_APP_S3_HOST}/image/recommend/${product.target_id}.jpg`}
                        />
                        <div className="related-product-menu">
                          <img
                            className="icon"
                            src={`${process.env.REACT_APP_HOST}/assets/images/product/search-icon.png`}
                          />
                          <img
                            className="icon"
                            src={`${process.env.REACT_APP_HOST}/assets/images/product/delete-icon.png`}
                            onClick={() => handleRelatedProductDelete(product)}
                          />
                        </div>
                      </div>
                      <div className="related-product-content-wrap">
                        <div className="related-product-list-wrap">
                          <div className="related-product-content-label">
                            브랜드명
                          </div>
                          <div className="related-product-content-text">
                            {product.product_brand_name}
                          </div>
                        </div>
                        <div className="related-product-list-wrap">
                          <div className="related-product-content-label">
                            상품명
                          </div>
                          <div className="related-product-content-text">
                            {product.product_name}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                  <div
                    key="related_product_add"
                    className="related-product-wrap"
                  >
                    <div className="related-product-index-wrap no-index"></div>
                    <img
                      className="related-product-image-wrap"
                      src={`${process.env.REACT_APP_HOST}/assets/images/product/add-product-icon.png`}
                      style={{ cursor: "pointer" }}
                      onClick={handleRelatedProductModalOpen}
                    />
                    <div className="related-product-content-wrap no-content"></div>
                  </div>
                </Row>
              </Form.Item>
            </div>
          </>
        )}

        {/*검색 태그*/}
        {user.role === "super_admin" && (
          <>
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className="product-register-box-title">검색 태그</span>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                borderTop: 0,
                padding: "20px 25px 80px",
                height: "fit-content",
              }}
            >
              <Form.Item
                label="검색태그"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                <Input
                  name="search_tag"
                  value={product.search_tag}
                  onChange={handleChange}
                />
                <div className="product-register-search-tag-help">
                  - 키워드는 콤마(,)로 구분하여 입력합니다.
                </div>
              </Form.Item>
            </div>
          </>
        )}

        {/*네이버 리뷰*/}
        {user.role === "super_admin" && (
          <>
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className="product-register-box-title">네이버 리뷰</span>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                borderTop: 0,
                padding: "20px 25px 80px",
                height: "fit-content",
              }}
            >
              <Form.Item
                label="네이버 상품 번호"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                <Input
                  name="product_id_naver"
                  value={product.product_id_naver}
                  onChange={handleChange}
                />
              </Form.Item>
            </div>
          </>
        )}

        {/*포인트 정책*/}
        {user.role === "super_admin" && (
          <>
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ marginTop: 20 }}
            >
              <span className="product-register-box-title">포인트 정책</span>
            </Row>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                borderTop: 0,
                padding: "20px 25px 0",
                height: "fit-content",
              }}
            >
              <Form.Item
                className="center-label"
                label="포인트 사용 여부"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 9 }}
              >
                <Radio.Group
                  name="is_available_point"
                  options={usabilityOptions}
                  onChange={handleChange}
                  value={product.is_available_point}
                  className="product-register-delivery-status-wrap"
                  optionType="button"
                  buttonStyle="solid"
                />
              </Form.Item>
              <Divider className="product-register-form-input-divider" />
              <Form.Item
                label="구매 포인트 지급"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 9 }}
              >
                <Radio.Group
                  name="saving_point"
                  options={paymentsOptions}
                  onChange={handleChange}
                  value={options.saving_point}
                  className="product-register-delivery-status-wrap"
                  optionType="button"
                  buttonStyle="solid"
                />
                <Input
                  type="number"
                  className="product-register-point-input-wrap"
                  name="saving_point"
                  value={product.saving_point}
                  min={0}
                  onChange={handleChange}
                  disabled={!options.saving_point}
                  addonAfter={
                    <Select
                      value={product.saving_point_type}
                      onChange={handleSelectChange}
                    >
                      {pointBenefitUnits.map((item, idx) => (
                        <Option
                          key={`point_benefit_type_${idx}`}
                          id="saving_point_type"
                          value={item.value}
                        >
                          {item.label}
                        </Option>
                      ))}
                    </Select>
                  }
                  style={{ width: 200 }}
                />
              </Form.Item>
              <Divider className="product-register-form-input-divider" />
              <Form.Item
                label="리뷰 작성 포인트 지급"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 21 }}
              >
                <Radio.Group
                  name="review_point"
                  options={paymentsOptions}
                  onChange={handleChange}
                  value={options.review_point}
                  className="product-register-delivery-status-wrap"
                  optionType="button"
                  buttonStyle="solid"
                />
                <Row className="product-register-point-group-wrap">
                  <Form.Item
                    className="center-label"
                    label="텍스트 리뷰 작성"
                    labelAlign="left"
                    colon={false}
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      type="number"
                      className="product-register-point-input-wrap"
                      name="review_point"
                      value={product.review_point}
                      min={0}
                      onChange={handleChange}
                      disabled={!options.review_point}
                      addonAfter={
                        <Select
                          value={product.review_point_type}
                          onChange={handleSelectChange}
                        >
                          {pointBenefitUnits.map((item, idx) => (
                            <Option
                              key={`text_review_point_benefit_type_${idx}`}
                              id="review_point_type"
                              value={item.value}
                            >
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    className="center-label"
                    label="이미지 첨부"
                    labelAlign="left"
                    colon={false}
                    // labelCol={{ span: 8 }}
                    // wrapperCol={{ span: 16 }}
                    style={{ marginBottom: 0 }}
                  >
                    <Input
                      type="number"
                      className="product-register-point-input-wrap"
                      name="review_image_point"
                      value={product.review_image_point}
                      min={0}
                      onChange={handleChange}
                      disabled={!options.review_point}
                      addonAfter={
                        <Select
                          value={product.review_image_point_type}
                          onChange={handleSelectChange}
                        >
                          {pointBenefitUnits.map((item, idx) => (
                            <Option
                              key={`image_review_point_benefit_type_${idx}`}
                              id="review_image_point_type"
                              value={item.value}
                            >
                              {item.label}
                            </Option>
                          ))}
                        </Select>
                      }
                    />
                  </Form.Item>
                </Row>
              </Form.Item>
              <Divider className="product-register-form-input-divider" />
              <Form.Item
                label="공유 포인트 지급"
                labelAlign="left"
                colon={false}
                labelCol={{ span: 3 }}
                wrapperCol={{ span: 9 }}
              >
                <Radio.Group
                  name="share_point"
                  options={paymentsOptions}
                  onChange={handleChange}
                  value={options.share_point}
                  className="product-register-delivery-status-wrap"
                  optionType="button"
                  buttonStyle="solid"
                />
                <Input
                  type="number"
                  className="product-register-point-input-wrap"
                  name="share_point"
                  value={product.share_point}
                  min={0}
                  onChange={handleChange}
                  disabled={!options.share_point}
                  addonAfter={<span className="product-price-label">원</span>}
                />
              </Form.Item>
            </div>
          </>
        )}

        {/*SEO*/}
        <>
          <Row
            className="product-register-border-box"
            wrap={false}
            style={{ marginTop: 20 }}
          >
            <span className="product-register-box-title">SEO</span>
          </Row>
          <div
            className="product-register-border-box"
            wrap={false}
            style={{
              borderTop: 0,
              padding: "20px 25px 0",
              height: "fit-content",
            }}
          >
            <Form.Item
              className="center-label pre-line"
              label={"브라우저 타이틀\n:Title"}
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input
                name="seo_title"
                value={product.seo_title}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            {/*<Form.Item*/}
            {/*    className="center-label pre-line"*/}
            {/*    label={"메타태그1\n:Author"}*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{ span: 3 }}*/}
            {/*    wrapperCol={{ span: 21 }}*/}
            {/*>*/}
            {/*    <Input*/}
            {/*        name="seo_author"*/}
            {/*        value={product.seo_author}*/}
            {/*        onChange={handleChange}*/}
            {/*    />*/}
            {/*</Form.Item>*/}
            {/*<Divider className="product-register-form-input-divider" />*/}
            <Form.Item
              className="product-register-form-input-wrap pre-line"
              label={"메타태그2\n:Description"}
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input.TextArea
                name="seo_description"
                value={product.seo_description}
                onChange={handleChange}
              />
            </Form.Item>
            <Divider className="product-register-form-input-divider" />
            <Form.Item
              className="pre-line"
              label={"메타태그3\n:Keywords"}
              labelAlign="left"
              colon={false}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 21 }}
            >
              <Input.TextArea
                name="seo_keywords"
                value={product.seo_keywords}
                onChange={handleChange}
                style={{ resize: "none", minHeight: 110 }}
              />
              <div className="product-register-search-tag-help">
                - 키워드는 콤마(,)로 구분하여 입력합니다.
              </div>
            </Form.Item>
            {/*<Divider className="product-register-form-input-divider" />*/}
            {/*<Form.Item*/}
            {/*    label="상품 이미지 Alt 텍스트"*/}
            {/*    labelAlign="left"*/}
            {/*    colon={false}*/}
            {/*    labelCol={{ span: 3 }}*/}
            {/*    wrapperCol={{ span: 21 }}*/}
            {/*>*/}
            {/*    <Input*/}
            {/*        name="seo_image_alt"*/}
            {/*        value={product.seo_image_alt}*/}
            {/*        onChange={handleChange}*/}
            {/*    />*/}
            {/*    <div className="product-register-search-tag-help">- Alt 텍스트는 해당 상품을 표현할 수 있는 1개 ~ 2개 정도의 단어로 입력하세요.</div>*/}
            {/*</Form.Item>*/}
          </div>
        </>

        {/* 예시 모달 */}
        <Modal
          className="related-product-modal-wrap"
          width={exampleTitle.id === "promotion" ? "45%" : "60%"}
          title={exampleTitle.title}
          visible={exampleShow}
          // maskClosable={false}
          onCancel={() => setExampleShow(!exampleShow)}
          footer={null}
        >
          {(exampleTitle.id === "tag" || exampleTitle.id === "exposure") && (
            <Menu className={`modal-tag-list`}>
              <MenuItem
                className={`${exampleTitle.id === "tag" ? "click" : ""}`}
                onClick={() =>
                  setExampleTitle({
                    ...exampleTitle,
                    id: "tag",
                  })
                }
              >
                태그 예시
              </MenuItem>
              <MenuItem
                className={`${exampleTitle.id !== "tag" ? "click" : ""}`}
                onClick={() =>
                  setExampleTitle({
                    ...exampleTitle,
                    id: "exposure",
                  })
                }
              >
                추가 설명 예시
              </MenuItem>
            </Menu>
          )}

          {exampleTitle.id === "main-image" ? (
            <div className={"example-modal-main-image-container"}>
              <div className={"main-image-div"}>
                <span>상하 여백 맞출 시, 좌우 가운데 정렬</span>
                <img
                  alt={`${exampleTitle.title}1`}
                  src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}1.jpg`}
                />
              </div>
              <div className={"main-image-div"}>
                <span>좌우 여백 맞출 시, 상하 가운데 정렬</span>
                <img
                  alt={`${exampleTitle.title}2`}
                  src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}2.jpg`}
                />
              </div>
            </div>
          ) : (
            <img
              alt={exampleTitle.title}
              src={`${process.env.REACT_APP_HOST}/assets/images/example/${exampleTitle.id}.png`}
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          )}
        </Modal>
      </div>
      <div className="product-register-fixed-footer">
        {/*<Button className="product-register-button temporary">임시저장</Button>*/}
        <Button
          className="product-register-button save"
          onClick={saveProduct}
          loading={isLoading}
        >
          {isLoading
            ? null
            : match.params.hasOwnProperty("id")
            ? "수정하기"
            : "저장하기"}
        </Button>
        <Button
          className="product-register-button cancel"
          onClick={cancelBtnClick}
        >
          취소
        </Button>
      </div>

      {/*상품설명 이미지 수정 Modal*/}
      {isExplainProductModalOpen && (
        <ProductDetailExplainComponent
          isExplainProductModalOpen={isExplainProductModalOpen}
          handleExplainProductModalCancel={handleExplainProductModalCancel}
          handleExplainProductModalOk={handleExplainProductModalOk}
          handleExplainProductImageSave={handleExplainProductImageSave}
          productDescriptionImg={productDescriptionImg}
          handleDeletedImageUid={handleDeletedImageUid}
          refProductDescriptionImg={refProductDescriptionImg}
          // productExplainImgList={productExplainImgList}
          clickImageUid={clickImageUid}
        />
      )}

      {/*연관상품등록 Modal*/}
      {isRelatedProductModalOpen && (
        <Modal
          className="related-product-modal-wrap"
          title={
            <div className="related-product-modal-header">연관 상품 등록</div>
          }
          visible={isRelatedProductModalOpen}
          onCancel={handleRelatedProductModalCancel}
          onOk={handleRelatedProductModalOk}
          width={"50%"}
          footer={
            <Row className="product-related-button-wrap" justify="center">
              <Button
                className="product-related-button search"
                onClick={handleRelatedProductModalOk}
              >
                등록
              </Button>
              <Button
                className="product-related-button cancel"
                onClick={handleRelatedProductModalCancel}
              >
                취소
              </Button>
            </Row>
          }
        >
          <div className="product-register-wrap related-product-modal-content-wrap">
            <Row
              className="product-register-border-box"
              wrap={false}
              style={{ backgroundColor: "#f8f9fd" }}
            >
              <span className="product-register-box-title">상품 검색</span>
            </Row>
            <div
              className="product-search-box-wrap"
              style={{
                marginTop: 0,
                borderTop: 0,
                borderBottom: 0,
                backgroundColor: "#f8f9fd",
              }}
            >
              <Row align="middle" style={{ marginBottom: 15 }}>
                <Col span={12} className="related-product-col-wrap">
                  <label className="product-search-box-input-label">
                    상품번호
                  </label>
                  <Input
                    className="product-search-box-input-wrap"
                    name="product_id"
                    value={
                      searchOptions.product_id === 0
                        ? ""
                        : searchOptions.product_id
                    }
                    onChange={handleProductSearchOptionChange}
                  />
                </Col>
                <Col span={12} className="related-product-col-wrap">
                  <label className="product-search-box-input-label">
                    제조사명
                  </label>
                  <Input
                    className="product-search-box-input-wrap"
                    name="product_maker_name"
                    value={searchOptions.product_maker_name}
                    onChange={handleProductSearchOptionChange}
                  />
                </Col>
              </Row>
              <Row align="middle" style={{ marginBottom: 50 }}>
                <Col span={12} className="related-product-col-wrap">
                  <label className="product-search-box-input-label">
                    상품명
                  </label>
                  <Input
                    className="product-search-box-input-wrap"
                    name="product_name"
                    value={searchOptions.product_name}
                    onChange={handleProductSearchOptionChange}
                  />
                </Col>
                <Col span={12} className="related-product-col-wrap">
                  <label className="product-search-box-input-label">
                    브랜드명
                  </label>
                  <Input
                    className="product-search-box-input-wrap"
                    name="product_brand_name"
                    value={searchOptions.product_brand_name}
                    onChange={handleProductSearchOptionChange}
                  />
                </Col>
              </Row>
              <Row className="product-search-button-wrap" justify="center">
                <Button
                  className="product-search-button search"
                  onClick={handleProductSearch}
                >
                  검색
                </Button>
                <Button
                  className="product-search-button initial"
                  onClick={handleInitialBtnClick}
                >
                  초기화
                </Button>
              </Row>
            </div>
            <div
              className="product-register-border-box"
              wrap={false}
              style={{
                padding: "20px 25px 35px",
                height: "fit-content",
                backgroundColor: "#f8f9fd",
              }}
            >
              <span className="product-register-box-title">
                상품 검색 결과(택1)
              </span>
              <Table
                className="product-list-table"
                rowSelection={rowSelection}
                columns={columns}
                dataSource={productItemList}
                loading={isLoading}
                bordered
                size="middle"
                rowKey="product_id"
                rowClassName="coupon-table-row"
                scroll={{ y: "calc(220px - 48px)" }}
                onRow={handleRowEvent}
                onChange={tableOnChange}
                pagination={false}
              />
              <span className="product-register-box-title">추천 이유</span>
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="recommend_reason"
                value={relatedProduct.recommend_reason}
                onChange={(e) =>
                  setRelatedProduct({
                    ...relatedProduct,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ProductRegisterComponent;
